import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { FiPlus, FiTrash2, FiEdit2, FiRefreshCw, FiFileText, FiX, FiChevronDown, FiChevronUp, FiSearch, FiAlertTriangle, FiDownload, FiLock, FiTarget, FiCheck, FiSave, FiArrowRight, FiClock, FiPlay, FiLoader, FiMapPin } from 'react-icons/fi';
import { faturamentoService, filterDataService } from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import { BIMultiSelectSearch, BIPeriodFilter, BIFilterSelect, BIPagination } from '../common';
import Loading from '../common/Loading';

const MESES = [
  { v: 1, n: 'Janeiro' }, { v: 2, n: 'Fevereiro' }, { v: 3, n: 'Março' },
  { v: 4, n: 'Abril' }, { v: 5, n: 'Maio' }, { v: 6, n: 'Junho' },
  { v: 7, n: 'Julho' }, { v: 8, n: 'Agosto' }, { v: 9, n: 'Setembro' },
  { v: 10, n: 'Outubro' }, { v: 11, n: 'Novembro' }, { v: 12, n: 'Dezembro' }
];

const DAYS_OF_WEEK_OPTIONS = [
  { id: 1, label: 'Seg', name: 'Segunda-feira' },
  { id: 2, label: 'Ter', name: 'Terça-feira' },
  { id: 3, label: 'Qua', name: 'Quarta-feira' },
  { id: 4, label: 'Qui', name: 'Quinta-feira' },
  { id: 5, label: 'Sex', name: 'Sexta-feira' },
  { id: 6, label: 'Sáb', name: 'Sábado' },
  { id: 0, label: 'Dom', name: 'Domingo' }
];

const PRESET_TIMES = ['07:00', '08:00', '12:00', '13:00', '18:00', '22:00'];

const MultiSelectSearch = BIMultiSelectSearch;

function Relatorios() {
  const { user: currentUser, hasSectionAccess } = useAuth();
  const isAdmin = currentUser?.role === 'admin';
  const canManage = hasSectionAccess('relatorios', 'manage');
  const [reports, setReports] = useState([]);
  const [allReports, setAllReports] = useState([]);
  const [goals, setGoals] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [expandedReportId, setExpandedReportId] = useState(null);
  const [selectedReportIds, setSelectedReportIds] = useState([]);
  const [vendorBranchMap, setVendorBranchMap] = useState({});
  const [modalBranchFilter, setModalBranchFilter] = useState([]);
  const [modalGoalYear, setModalGoalYear] = useState(String(new Date().getFullYear()));
  const [modalGoalMonth, setModalGoalMonth] = useState(String(new Date().getMonth() + 1));

  // Modal de confirmação de exclusão
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [reportToDelete, setReportToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorModalTitle, setErrorModalTitle] = useState('Erro ao Salvar');

  // Modal de confirmação de reprocessamento
  const [showReprocessModal, setShowReprocessModal] = useState(false);
  const [reportToReprocess, setReportToReprocess] = useState(null);
  const [reprocessing, setReprocessing] = useState(false);

  const [expandedCalcVarId, setExpandedCalcVarId] = useState(null);

  // Modal de confirmação de reprocessamento em lote
  const [showBulkReprocessModal, setShowBulkReprocessModal] = useState(false);
  const [bulkReprocessing, setBulkReprocessing] = useState(false);

  // Modal de confirmação de exclusão em lote
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
  const [bulkDeleting, setBulkDeleting] = useState(false);

  // Modal de finalização
  const [showFinalizeModal, setShowFinalizeModal] = useState(false);
  const [reportToFinalize, setReportToFinalize] = useState(null);
  const [finalizing, setFinalizing] = useState(false);

  // Modal de finalização em lote
  const [showBulkFinalizeModal, setShowBulkFinalizeModal] = useState(false);
  const [bulkFinalizing, setBulkFinalizing] = useState(false);

  // Modal de processamento
  const [showProcessingModal, setShowProcessingModal] = useState(false);
  const [processingMessage, setProcessingMessage] = useState('');

  // Modal de verificação de regras de acréscimo com relatórios
  const [showAccrualModal, setShowAccrualModal] = useState(false);
  const [accrualRules, setAccrualRules] = useState([]);
  const [accrualRulesToReplace, setAccrualRulesToReplace] = useState([]);
  const accrualRulesToReplaceRef = useRef([]);
  const pendingAccrualPayloadRef = useRef(null);

  // Modal de aviso de meta com relatório existente
  const [showExistingReportWarning, setShowExistingReportWarning] = useState(false);
  const [existingReportWarnings, setExistingReportWarnings] = useState([]);

  // Modal e gerenciamento de Agendamentos de Sincronização
  const [showSyncScheduleModal, setShowSyncScheduleModal] = useState(false);
  const [syncSchedules, setSyncSchedules] = useState([]);
  const [loadingSyncSchedules, setLoadingSyncSchedules] = useState(false);
  const [syncScheduleSubTab, setSyncScheduleSubTab] = useState('list'); // 'list' | 'form'
  const [syncScheduleForm, setSyncScheduleForm] = useState({
    id: null,
    name: '',
    scheduled_times: ['08:00', '13:00', '18:00'],
    timeInput: '',
    days_of_week: [1, 2, 3, 4, 5],
    classifications: [],
    subtypes: [],
    target_types: [],
    branches: [],
    period_mode: 'current_month',
    reference_year: new Date().getFullYear(),
    reference_month: new Date().getMonth() + 1,
    is_active: true
  });
  const [syncSchedulePreview, setSyncSchedulePreview] = useState(null);
  const [loadingSchedulePreview, setLoadingSchedulePreview] = useState(false);
  const [savingSyncSchedule, setSavingSyncSchedule] = useState(false);
  const [runningScheduleId, setRunningScheduleId] = useState(null);
  const [scheduleDeleteConfirm, setScheduleDeleteConfirm] = useState(null);
  const [scheduleActionFeedback, setScheduleActionFeedback] = useState(null);

  const parseVariableIds = (input) => {
    if (Array.isArray(input)) return input;
    if (typeof input === 'string' && input) return input.split(',').map(v => parseInt(v, 10)).filter(v => !isNaN(v));
    return [];
  };

  const defaultPeriod = (() => {
    const now = new Date();
    const day = now.getDate();
    let year = now.getFullYear();
    let month = now.getMonth() + 1;
    if (day <= 8) {
      month -= 1;
      if (month === 0) { month = 12; year -= 1; }
    }
    const pad = (n) => String(n).padStart(2, '0');
    const end = new Date(year, month, 0);
    return {
      monthValue: `${year}-${pad(month)}`,
      period_start: `${year}-${pad(month)}-01`,
      period_end: `${year}-${pad(month)}-${pad(end.getDate())}`
    };
  })();

  // Filtros (multi-select)
  const [filters, setFilters] = useState({
    status: [],
    branch_ids: [],
    vendor_ids: [],
    employee_ids: [],
    goal_ids: [],
    report_ids: [],
    target_type: '',
    goal_type: '',
    goal_classification: '',
    period_start: defaultPeriod.period_start,
    period_end: defaultPeriod.period_end,
    finalized: 'no'
  });

  const [form, setForm] = useState({
    id: null,
    name: '',
    goal_ids: [],
    period_start: '',
    period_end: '',
    status: 'draft'
  });

  const [selectedMonth, setSelectedMonth] = useState('');
  const [filterSelectedMonth, setFilterSelectedMonth] = useState(defaultPeriod.monthValue);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sortField, setSortField] = useState('created_at');
  const [sortOrder, setSortOrder] = useState('desc');
  const [employees, setEmployees] = useState([]);

  const handleSort = (field) => {
    let newOrder = 'asc';
    if (sortField === field) {
      newOrder = sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      newOrder = (field === 'created_at' || field === 'period') ? 'desc' : 'asc';
    }
    setSortField(field);
    setSortOrder(newOrder);
    setPage(1);
    loadData({ ...getFilterParams(), page: 1, sort_by: field, sort_order: newOrder });
  };

  const renderSortIcon = (field) => {
    if (sortField !== field) return <span style={{ marginLeft: 4, opacity: 0.25, fontSize: 10, userSelect: 'none' }}>▲▼</span>;
    return <span style={{ marginLeft: 4, fontSize: 10, userSelect: 'none' }}>{sortOrder === 'asc' ? '▲' : '▼'}</span>;
  };

  const getMonthDates = (year, month) => {
    const start = new Date(year, month - 1, 1);
    const end = new Date(year, month, 0);
    const pad = (n) => String(n).padStart(2, '0');
    return {
      period_start: `${year}-${pad(month)}-01`,
      period_end: `${year}-${pad(month)}-${pad(end.getDate())}`
    };
  };

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    if (!value) return;
    const [year, month] = value.split('-').map(Number);
    const dates = getMonthDates(year, month);
    setForm((prev) => ({ ...prev, ...dates }));
  };

  const handleFilterMonthChange = (value) => {
    setFilterSelectedMonth(value);
    if (!value) {
      setFilters((prev) => ({ ...prev, period_start: '', period_end: '' }));
      return;
    }
    const [year, month] = value.split('-').map(Number);
    const dates = getMonthDates(year, month);
    setFilters((prev) => ({ ...prev, ...dates }));
  };

  const handleApplyPeriodPreset = (presetKey) => {
    const curMonthVal = filterSelectedMonth || defaultPeriod.monthValue;
    const [year, month] = curMonthVal ? curMonthVal.split('-').map(Number) : [new Date().getFullYear(), new Date().getMonth() + 1];
    const pad = (n) => String(n).padStart(2, '0');
    const lastDay = new Date(year, month, 0).getDate();

    let start = '';
    let end = '';

    if (presetKey === 'month') {
      start = `${year}-${pad(month)}-01`;
      end = `${year}-${pad(month)}-${pad(lastDay)}`;
    } else if (presetKey === '1q') {
      start = `${year}-${pad(month)}-01`;
      end = `${year}-${pad(month)}-15`;
    } else if (presetKey === '2q') {
      start = `${year}-${pad(month)}-16`;
      end = `${year}-${pad(month)}-${pad(lastDay)}`;
    } else if (presetKey === 'yesterday') {
      const today = new Date();
      today.setDate(today.getDate() - 1);
      start = `${year}-${pad(month)}-01`;
      end = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
    }

    if (start && end) {
      setFilters((prev) => ({ ...prev, period_start: start, period_end: end }));
    }
  };

  const loadSyncSchedules = useCallback(async () => {
    try {
      setLoadingSyncSchedules(true);
      const res = await faturamentoService.listSyncSchedules();
      const list = res?.data?.schedules || (Array.isArray(res?.data) ? res.data : []);
      setSyncSchedules(list);
    } catch (err) {
      console.error('Erro ao carregar agendamentos de sincronização:', err);
    } finally {
      setLoadingSyncSchedules(false);
    }
  }, []);

  const activeRequestId = useRef(0);

  const buildFilterParams = useCallback((filtersObj, searchStr, pageNum = page, customPerPage = perPage, customSortField = sortField, customSortOrder = sortOrder) => {
    const params = { page: pageNum, per_page: customPerPage, sort_by: customSortField, sort_order: customSortOrder };
    const curFilters = filtersObj || filters;
    const curSearch = searchStr !== undefined ? searchStr : searchTerm;

    if (curSearch && curSearch.trim()) params.search = curSearch.trim();
    if (curFilters.status && curFilters.status.length > 0) params.status = curFilters.status.join(',');
    if (curFilters.branch_ids && curFilters.branch_ids.length > 0) params.branch = curFilters.branch_ids.join(',');
    if (curFilters.vendor_ids && curFilters.vendor_ids.length > 0) params.vendor_id = curFilters.vendor_ids.join(',');
    if (curFilters.employee_ids && curFilters.employee_ids.length > 0) params.employee_id = curFilters.employee_ids.join(',');
    if (curFilters.goal_ids && curFilters.goal_ids.length > 0) params.goal_id = curFilters.goal_ids.join(',');
    if (curFilters.target_type) params.target_type = curFilters.target_type;
    if (curFilters.goal_type) params.goal_type = curFilters.goal_type;
    if (curFilters.goal_classification) params.goal_classification = curFilters.goal_classification;
    if (curFilters.period_start) {
      params.period_start = curFilters.period_start;
      params.start_date = curFilters.period_start;
    }
    if (curFilters.period_end) {
      params.period_end = curFilters.period_end;
      params.end_date = curFilters.period_end;
    }
    if (curFilters.finalized) params.finalized = curFilters.finalized;
    return params;
  }, [filters, searchTerm, page, perPage, sortField, sortOrder]);

  const getFilterParams = useCallback(() => {
    return buildFilterParams(filters, searchTerm, page, perPage, sortField, sortOrder);
  }, [buildFilterParams, filters, searchTerm, page, perPage, sortField, sortOrder]);

  const filterParamsRef = useRef(getFilterParams);
  filterParamsRef.current = getFilterParams;

  const loadData = useCallback(async (filterParams = {}, silent = false, fullReload = false) => {
    if (!silent) setLoading(true);
    const reqId = ++activeRequestId.current;
    try {
      const isInitialOrFull = fullReload || branches.length === 0 || goals.length === 0;

      if (!isInitialOrFull) {
        // Caminho otimizado: busca somente a página de relatórios (imediato e ultrarrápido)
        const reportsRes = await faturamentoService.listReports(filterParams);
        if (reqId !== activeRequestId.current) return;
        const loadedReports = reportsRes?.data?.reports || [];
        setReports(loadedReports);
        setTotalRecords(reportsRes?.data?.total || 0);
        setSelectedReportIds((prev) => prev.filter((id) => loadedReports.some((r) => Number(r.id) === Number(id))));
        return;
      }

      // Carga completa: metadados (metas, filiais, vendedores, funcionários) + relatórios
      const allReportsParams = { per_page: 10000 };
      if (filterParams.period_start) {
        allReportsParams.period_start = filterParams.period_start;
        allReportsParams.start_date = filterParams.period_start;
      }
      if (filterParams.period_end) {
        allReportsParams.period_end = filterParams.period_end;
        allReportsParams.end_date = filterParams.period_end;
      }

      const goalsParams = { per_page: 10000 };
      if (filterParams.period_start) {
        goalsParams.period_start = filterParams.period_start;
        goalsParams.start_date = filterParams.period_start;
      }
      if (filterParams.period_end) {
        goalsParams.period_end = filterParams.period_end;
        goalsParams.end_date = filterParams.period_end;
      }

      const [reportsRes, allReportsRes, goalsRes, branchesRes, vendorsRes] = await Promise.all([
        faturamentoService.listReports(filterParams),
        faturamentoService.listReports(allReportsParams),
        faturamentoService.listGoals(goalsParams),
        filterDataService.getFiliais(),
        filterDataService.getVendedores('', 10000, 0)
      ]);

      if (reqId !== activeRequestId.current) return;

      const loadedReports = reportsRes?.data?.reports || [];
      const loadedAllReports = allReportsRes?.data?.reports || [];
      setReports(loadedReports);
      setAllReports(loadedAllReports);
      setTotalRecords(reportsRes?.data?.total || 0);
      setSelectedReportIds((prev) => prev.filter((id) => loadedReports.some((r) => Number(r.id) === Number(id))));
      setGoals(goalsRes?.data?.goals || []);

      // Extrair vendedores únicos das metas
      const uniqueVendors = [];
      const seenVendors = new Set();
      (goalsRes?.data?.goals || []).forEach(g => {
        if (g.vendor_id && !seenVendors.has(g.vendor_id)) {
          seenVendors.add(g.vendor_id);
          uniqueVendors.push({ id: g.vendor_id, nome: g.vendor_name || `Vendedor #${g.vendor_id}` });
        }
      });
      setVendors(uniqueVendors);

      // Carregar filiais
      const filiaisData = branchesRes?.data?.filiais || [];
      setBranches(filiaisData.map(b => ({ id: String(b.codigo), label: `${b.codigo} - ${b.nomefantasia || b.razaosocial || 'Sem nome'}` })));

      // Mapa vendedor -> filial
      const vendorsData = vendorsRes?.data?.vendedores || [];
      const vMap = {};
      vendorsData.forEach(v => {
        vMap[String(v.id)] = v.codfilial != null ? String(v.codfilial) : '';
      });
      setVendorBranchMap(vMap);

      // Carregar funcionários (via API ou extração das metas)
      let employeesList = [];
      try {
        const empRes = await faturamentoService.listEmployees({ per_page: 10000, ativo: 1 });
        employeesList = empRes?.data?.employees || [];
      } catch (e) {
        console.warn('Erro ao carregar lista de funcionários:', e);
      }
      const seenEmployees = new Set(employeesList.map(e => Number(e.id)));
      (goalsRes?.data?.goals || []).forEach(g => {
        if (g.employee_id && !seenEmployees.has(Number(g.employee_id))) {
          seenEmployees.add(Number(g.employee_id));
          employeesList.push({
            id: g.employee_id,
            nome: g.employee_name || `Funcionário #${g.employee_id}`,
            branch_code: g.employee_codfilial ? String(g.employee_codfilial) : ''
          });
        }
      });
      setEmployees(employeesList);
      loadSyncSchedules();
    } catch (e) {
      if (!silent) setMessage({ type: 'danger', text: e.response?.data?.error || 'Erro ao carregar relatórios' });
    } finally {
      if (!silent && reqId === activeRequestId.current) setLoading(false);
    }
  }, [branches.length, goals.length, loadSyncSchedules]);

  const applyFilters = () => {
    setPage(1);
    loadData(buildFilterParams(filters, searchTerm, 1));
  };

  const clearFilters = () => {
    setSearchTerm('');
    const emptyFilters = {
      status: [],
      branch_ids: [],
      vendor_ids: [],
      employee_ids: [],
      goal_ids: [],
      report_ids: [],
      target_type: '',
      goal_type: '',
      goal_classification: '',
      period_start: '',
      period_end: '',
      finalized: ''
    };
    setFilters(emptyFilters);
    setFilterSelectedMonth('');
    setPage(1);
    loadData(buildFilterParams(emptyFilters, '', 1));
  };

  // Carga inicial completa de relatórios e metadados ao montar o componente
  useEffect(() => {
    loadData(buildFilterParams(filters, searchTerm, 1), false, true);
    loadSyncSchedules();
  }, []);

  // Aplicação IMEDIATA de filtros ao selecionar qualquer opção (sem temporizador)
  const filtersLoaded = useRef(false);
  useEffect(() => {
    if (!filtersLoaded.current) {
      filtersLoaded.current = true;
      return;
    }
    setPage(1);
    loadData(buildFilterParams(filters, searchTerm, 1));
  }, [filters]);

  // Busca textual: debounce leve apenas para digitação no input de busca
  const searchLoaded = useRef(false);
  useEffect(() => {
    if (!searchLoaded.current) {
      searchLoaded.current = true;
      return;
    }
    const timer = setTimeout(() => {
      setPage(1);
      loadData(buildFilterParams(filters, searchTerm, 1));
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  // Opções filtradas de vendedores e funcionários com base na filial selecionada
  const filteredVendors = useMemo(() => {
    if (!filters.branch_ids || filters.branch_ids.length === 0) {
      return vendors;
    }
    const selectedBranches = filters.branch_ids.map(String);
    return vendors.filter(v => {
      const bCode = vendorBranchMap[String(v.id)] || (v.branch_code ? String(v.branch_code).trim() : '');
      if (!bCode) return true;
      return selectedBranches.includes(bCode);
    });
  }, [vendors, filters.branch_ids, vendorBranchMap]);

  const filteredEmployees = useMemo(() => {
    if (!filters.branch_ids || filters.branch_ids.length === 0) {
      return employees;
    }
    const selectedBranches = filters.branch_ids.map(String);
    return employees.filter(e => {
      if (!e.branch_code) return true;
      return selectedBranches.includes(String(e.branch_code).trim());
    });
  }, [employees, filters.branch_ids]);

  // Autoload silencioso para progresso de processamento
  useEffect(() => {
    const timer = setInterval(() => {
      // Só atualiza se não estiver carregando manualmente para evitar sobreposição
      if (loading) return;

      loadData(filterParamsRef.current(), true);
    }, 5000); // 5 segundos
    
    return () => clearInterval(timer);
  }, [loadData, loading]);

  const resetForm = () => {
    setForm({ id: null, name: '', goal_ids: [], period_start: '', period_end: '', status: 'draft' });
    setSelectedMonth('');
    setModalBranchFilter([]);
    setModalGoalYear(String(new Date().getFullYear()));
    setModalGoalMonth(String(new Date().getMonth() + 1));
  };

  const toggleExpand = (reportId) => {
    setExpandedReportId(expandedReportId === reportId ? null : reportId);
  };

  const formatCurrency = (value) => {
    if (value === null || value === undefined) return '-';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  };

  const formatNumber = (value) => {
    if (value === null || value === undefined) return '-';
    return new Intl.NumberFormat('pt-BR').format(value);
  };
  const formatPercent = (value) => {
    if (value === null || value === undefined) return '-';
    return `${Number(value).toFixed(2)}%`;
  };

  const branchNameMap = useMemo(() => {
    const map = {};
    (branches || []).forEach(b => {
      map[String(b.id)] = b.label;
    });
    return map;
  }, [branches]);

  const employeeBranchMap = useMemo(() => {
    const map = {};
    (employees || []).forEach(e => {
      const b = e.branch_code || e.codfilial;
      if (b != null && b !== '') {
        map[String(e.id)] = String(b).trim();
      }
    });
    return map;
  }, [employees]);

  // Resolução sucessiva da filial do relatório: 1. Backend/Preset -> 2. Vendedor -> 3. Funcionário -> 4. Meta Vinculada
  const resolveReportBranch = useCallback((r) => {
    if (!r) return null;
    // 1. Dados resolvidos diretamente pelo backend via enrichReportsWithBranchInfo (que já aplica a sucessão rigorosa)
    if (r.branch_code) {
      return {
        code: String(r.branch_code).trim(),
        name: r.branch_name || `Filial ${r.branch_code}`,
        source: 'backend'
      };
    }
    // 2. Vendedor vinculado ao relatório / meta
    if (r.vendor_id) {
      const vCode = vendorBranchMap[String(r.vendor_id)] || (r.vendor_codfilial ? String(r.vendor_codfilial) : null);
      if (vCode) {
        return {
          code: String(vCode).trim(),
          name: r.branch_name || (branchNameMap[String(vCode)] ? branchNameMap[String(vCode)] : `Filial ${vCode}`),
          source: 'vendor'
        };
      }
    }
    // 3. Funcionário vinculado ao relatório / meta
    if (r.employee_id) {
      const eCode = employeeBranchMap[String(r.employee_id)] || (r.employee_codfilial ? String(r.employee_codfilial) : null);
      if (eCode) {
        return {
          code: String(eCode).trim(),
          name: r.branch_name || (branchNameMap[String(eCode)] ? branchNameMap[String(eCode)] : `Filial ${eCode}`),
          source: 'employee'
        };
      }
    }
    // 4. Meta vinculada ao relatório
    if (r.goal_id && goals && goals.length > 0) {
      const g = goals.find(item => Number(item.id) === Number(r.goal_id));
      if (g) {
        if (g.branch_code) {
          return {
            code: String(g.branch_code).trim(),
            name: g.branch_name || `Filial ${g.branch_code}`,
            source: 'goal'
          };
        }
        if (g.vendor_codfilial) {
          return {
            code: String(g.vendor_codfilial).trim(),
            name: g.branch_name || `Filial ${g.vendor_codfilial}`,
            source: 'goal_vendor'
          };
        }
        if (g.employee_codfilial) {
          return {
            code: String(g.employee_codfilial).trim(),
            name: g.branch_name || `Filial ${g.employee_codfilial}`,
            source: 'goal_employee'
          };
        }
      }
    }
    return null;
  }, [branchNameMap, vendorBranchMap, employeeBranchMap, goals]);

  const resolveReportBranchBadge = (r) => {
    const branchInfo = resolveReportBranch(r);
    if (!branchInfo || !branchInfo.code) {
      return <span className="text-muted small">-</span>;
    }
    const codes = String(branchInfo.code).split(',').map(c => c.trim()).filter(Boolean);
    return (
      <div className="d-flex flex-column align-items-start gap-1">
        <div className="d-flex flex-wrap gap-1 align-items-center">
          {codes.map((code) => (
            <span
              key={code}
              className="badge-modern"
              style={{
                backgroundColor: '#fef3c7',
                color: '#92400e',
                border: '1px solid #fde68a',
                fontWeight: 600,
                fontSize: '0.72rem',
                padding: '2px 7px',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '3px',
                whiteSpace: 'nowrap'
              }}
              title={`Filial ${code}`}
            >
              <FiMapPin size={11} />
              Filial {code}
            </span>
          ))}
        </div>
        {branchInfo.name && branchInfo.name !== `Filial ${branchInfo.code}` && (
          <span
            className="text-muted"
            style={{ fontSize: '0.72rem', maxWidth: '160px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            title={branchInfo.name}
          >
            {branchInfo.name}
          </span>
        )}
      </div>
    );
  };

  const edit = (r) => {
    setForm({
      id: r.id,
      name: r.name || '',
      goal_ids: r.goal_id ? [Number(r.goal_id)] : [],
      period_start: r.period_start ? String(r.period_start).slice(0, 10) : '',
      period_end: r.period_end ? String(r.period_end).slice(0, 10) : '',
      status: r.status || 'draft'
    });
    setSelectedMonth('');
    setModalBranchFilter([]);
    setModalGoalYear(String(new Date().getFullYear()));
    setModalGoalMonth(String(new Date().getMonth() + 1));
    setShowModal(true);
  };

  const openNewModal = () => {
    resetForm();
    setShowModal(true);
  };

  const activeSchedulesCount = useMemo(() => {
    return (syncSchedules || []).filter(s => s.is_active).length;
  }, [syncSchedules]);

  const openSyncScheduleModal = () => {
    setSyncScheduleSubTab('list');
    setScheduleActionFeedback(null);
    setScheduleDeleteConfirm(null);
    loadSyncSchedules();
    setShowSyncScheduleModal(true);
  };

  const fetchSchedulePreview = useCallback(async (criteria) => {
    try {
      setLoadingSchedulePreview(true);
      const res = await faturamentoService.previewSyncSchedule({ report_types: criteria });
      if (res?.success) {
        setSyncSchedulePreview(res.data);
      }
    } catch (e) {
      console.warn('Erro ao carregar estimativa de agendamento:', e);
    } finally {
      setLoadingSchedulePreview(false);
    }
  }, []);

  // Auto-atualizar estimativa de relatórios do agendamento com debounce quando qualquer critério mudar
  useEffect(() => {
    if (!showSyncScheduleModal || syncScheduleSubTab !== 'form') return;
    const timer = setTimeout(() => {
      fetchSchedulePreview({
        classifications: syncScheduleForm.classifications,
        subtypes: syncScheduleForm.subtypes,
        target_types: syncScheduleForm.target_types,
        branches: syncScheduleForm.branches,
        period_mode: syncScheduleForm.period_mode,
        reference_year: syncScheduleForm.reference_year,
        reference_month: syncScheduleForm.reference_month
      });
    }, 250);
    return () => clearTimeout(timer);
  }, [
    showSyncScheduleModal,
    syncScheduleSubTab,
    syncScheduleForm.classifications,
    syncScheduleForm.subtypes,
    syncScheduleForm.target_types,
    syncScheduleForm.branches,
    syncScheduleForm.period_mode,
    syncScheduleForm.reference_year,
    syncScheduleForm.reference_month,
    fetchSchedulePreview
  ]);

  const openNewScheduleForm = () => {
    const defaultData = {
      id: null,
      name: '',
      scheduled_times: ['08:00', '13:00', '18:00'],
      timeInput: '',
      days_of_week: [1, 2, 3, 4, 5],
      classifications: [],
      subtypes: [],
      target_types: [],
      branches: [],
      period_mode: 'current_month',
      reference_year: new Date().getFullYear(),
      reference_month: new Date().getMonth() + 1,
      is_active: true
    };
    setSyncScheduleForm(defaultData);
    setScheduleActionFeedback(null);
    setSyncSchedulePreview(null);
    setSyncScheduleSubTab('form');
  };

  const openEditScheduleForm = (s) => {
    let times = [];
    if (Array.isArray(s.scheduled_time)) {
      times = s.scheduled_time;
    } else if (typeof s.scheduled_time === 'string') {
      try {
        const parsed = JSON.parse(s.scheduled_time);
        times = Array.isArray(parsed) ? parsed : [s.scheduled_time];
      } catch (e) {
        times = s.scheduled_time.split(',').map(t => t.trim()).filter(Boolean);
      }
    }

    const reportTypes = s.report_types || {};
    const formData = {
      id: s.id,
      name: s.name || '',
      scheduled_times: times.length > 0 ? times : ['08:00'],
      timeInput: '',
      days_of_week: Array.isArray(s.days_of_week) ? s.days_of_week : [1, 2, 3, 4, 5],
      classifications: reportTypes.classifications || [],
      subtypes: reportTypes.subtypes || [],
      target_types: reportTypes.target_types || [],
      branches: reportTypes.branches || [],
      period_mode: reportTypes.period_mode || 'current_month',
      reference_year: reportTypes.reference_year ? Number(reportTypes.reference_year) : new Date().getFullYear(),
      reference_month: reportTypes.reference_month ? Number(reportTypes.reference_month) : (new Date().getMonth() + 1),
      is_active: !!s.is_active
    };

    setSyncScheduleForm(formData);
    setScheduleActionFeedback(null);
    setSyncScheduleSubTab('form');
  };

  const handleToggleSchedule = async (id) => {
    try {
      const res = await faturamentoService.toggleSyncSchedule(id);
      if (res?.success) {
        setSyncSchedules(prev => prev.map(s => s.id === id ? { ...s, is_active: res.data?.is_active ? 1 : 0 } : s));
      }
    } catch (err) {
      setScheduleActionFeedback({ type: 'danger', text: err.response?.data?.error || 'Erro ao alternar status do agendamento.' });
    }
  };

  const handleRunScheduleNow = async (id) => {
    try {
      setRunningScheduleId(id);
      setScheduleActionFeedback(null);
      const res = await faturamentoService.runSyncScheduleNow(id);
      if (res?.success) {
        setScheduleActionFeedback({
          type: 'success',
          text: `Sincronização iniciada com sucesso! ${res.data?.triggered_count || 0} relatório(s) colocados na fila para atualização.`
        });
        await loadSyncSchedules();
        loadData(getFilterParams(), true);
      }
    } catch (err) {
      setScheduleActionFeedback({ type: 'danger', text: err.response?.data?.error || 'Erro ao executar rotina de sincronização.' });
    } finally {
      setRunningScheduleId(null);
    }
  };

  const handleDeleteSchedule = async (id) => {
    try {
      const res = await faturamentoService.deleteSyncSchedule(id);
      if (res?.success) {
        setSyncSchedules(prev => prev.filter(s => s.id !== id));
        setScheduleDeleteConfirm(null);
        setScheduleActionFeedback({ type: 'success', text: 'Agendamento removido com sucesso.' });
      }
    } catch (err) {
      setScheduleActionFeedback({ type: 'danger', text: err.response?.data?.error || 'Erro ao excluir agendamento.' });
    }
  };

  const handleSaveSchedule = async (e) => {
    if (e) e.preventDefault();
    if (!syncScheduleForm.name.trim()) {
      setScheduleActionFeedback({ type: 'warning', text: 'Informe um nome descritivo para a rotina de sincronização.' });
      return;
    }
    if (!syncScheduleForm.scheduled_times || syncScheduleForm.scheduled_times.length === 0) {
      setScheduleActionFeedback({ type: 'warning', text: 'Adicione pelo menos um horário de execução.' });
      return;
    }
    if (!syncScheduleForm.days_of_week || syncScheduleForm.days_of_week.length === 0) {
      setScheduleActionFeedback({ type: 'warning', text: 'Selecione pelo menos um dia da semana para a rotina.' });
      return;
    }

    try {
      setSavingSyncSchedule(true);
      setScheduleActionFeedback(null);
      const payload = {
        name: syncScheduleForm.name.trim(),
        scheduled_time: syncScheduleForm.scheduled_times,
        days_of_week: syncScheduleForm.days_of_week,
        report_types: {
          classifications: syncScheduleForm.classifications,
          subtypes: syncScheduleForm.subtypes,
          target_types: syncScheduleForm.target_types,
          branches: syncScheduleForm.branches,
          period_mode: syncScheduleForm.period_mode,
          reference_year: syncScheduleForm.reference_year,
          reference_month: syncScheduleForm.reference_month
        },
        is_active: syncScheduleForm.is_active ? 1 : 0
      };

      if (syncScheduleForm.id) {
        await faturamentoService.updateSyncSchedule(syncScheduleForm.id, payload);
      } else {
        await faturamentoService.createSyncSchedule(payload);
      }

      await loadSyncSchedules();
      setSyncScheduleSubTab('list');
      setScheduleActionFeedback({
        type: 'success',
        text: syncScheduleForm.id ? 'Rotina de sincronização atualizada com sucesso!' : 'Rotina de sincronização cadastrada com sucesso!'
      });
    } catch (err) {
      setScheduleActionFeedback({ type: 'danger', text: err.response?.data?.error || 'Erro ao salvar agendamento.' });
    } finally {
      setSavingSyncSchedule(false);
    }
  };

  const handleAddScheduleTime = (timeStr) => {
    const t = (timeStr || syncScheduleForm.timeInput || '').trim();
    if (!t) return;
    const parts = t.split(':');
    if (parts.length < 2) return;
    const formatted = `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}`;
    if (!syncScheduleForm.scheduled_times.includes(formatted)) {
      const updatedTimes = [...syncScheduleForm.scheduled_times, formatted].sort();
      setSyncScheduleForm(prev => ({
        ...prev,
        scheduled_times: updatedTimes,
        timeInput: ''
      }));
    } else {
      setSyncScheduleForm(prev => ({ ...prev, timeInput: '' }));
    }
  };

  const handleRemoveScheduleTime = (timeStr) => {
    setSyncScheduleForm(prev => ({
      ...prev,
      scheduled_times: prev.scheduled_times.filter(t => t !== timeStr)
    }));
  };

  const handleToggleScheduleDay = (dayId) => {
    setSyncScheduleForm(prev => {
      const exists = prev.days_of_week.includes(dayId);
      const updatedDays = exists
        ? prev.days_of_week.filter(d => d !== dayId)
        : [...prev.days_of_week, dayId].sort((a, b) => a - b);
      return { ...prev, days_of_week: updatedDays };
    });
  };

  const handleToggleClassification = (val) => {
    setSyncScheduleForm(prev => {
      const exists = prev.classifications.includes(val);
      const next = exists ? prev.classifications.filter(c => c !== val) : [...prev.classifications, val];
      return { ...prev, classifications: next };
    });
  };

  const handleToggleSubtype = (val) => {
    setSyncScheduleForm(prev => {
      const exists = prev.subtypes.includes(val);
      const next = exists ? prev.subtypes.filter(s => s !== val) : [...prev.subtypes, val];
      return { ...prev, subtypes: next };
    });
  };

  const handleToggleTargetType = (val) => {
    setSyncScheduleForm(prev => {
      const exists = prev.target_types.includes(val);
      const next = exists ? prev.target_types.filter(t => t !== val) : [...prev.target_types, val];
      return { ...prev, target_types: next };
    });
  };

  const handleToggleScheduleBranch = (branchCode) => {
    setSyncScheduleForm(prev => {
      const exists = prev.branches.includes(branchCode);
      const next = exists ? prev.branches.filter(b => b !== branchCode) : [...prev.branches, branchCode];
      return { ...prev, branches: next };
    });
  };

  const handleChangePeriodMode = (mode) => {
    setSyncScheduleForm(prev => ({ ...prev, period_mode: mode }));
  };

  const saveReport = async (payload, isUpdate) => {
    showProcessing('Salvando relatório...');
    setSaving(true);
    try {
      let reportId = null;
      if (isUpdate) {
        await faturamentoService.updateReport(form.id, payload);
        reportId = form.id;
        setMessage({ type: 'success', text: 'Relatorio atualizado.' });
      } else {
        const createRes = await faturamentoService.createReport(payload);
        reportId = createRes?.data?.report?.id;
        setMessage({ type: 'success', text: 'Relatorio cadastrado.' });
      }
      resetForm();
      setShowModal(false);
      await loadData(getFilterParams());
      return reportId;
    } catch (err) {
      const errorMsg = err.response?.data?.error || 'Erro ao salvar relatório';
      if (showModal) {
        setErrorModalTitle('Erro ao Salvar');
        setErrorMessage(errorMsg);
        setShowErrorModal(true);
      } else {
        setMessage({ type: 'danger', text: errorMsg });
      }
      return null;
    } finally {
      setSaving(false);
      hideProcessing();
    }
  };

  const toggleAccrualReplace = (ruleId) => {
    setAccrualRulesToReplace((prev) => {
      const next = prev.includes(ruleId) ? prev.filter((id) => id !== ruleId) : [...prev, ruleId];
      accrualRulesToReplaceRef.current = next;
      return next;
    });
  };

  const handleAccrualSave = async () => {
    const payload = pendingAccrualPayloadRef.current;
    if (!payload) return;
    setShowAccrualModal(false);
    showProcessing('Salvando relatório e atualizando regras...');
    setSaving(true);
    try {
      const createRes = await faturamentoService.createReport(payload);
      const newReportId = createRes?.data?.report?.id;
      let replaceSuccess = 0;
      let replaceFail = 0;
      const toReplace = accrualRulesToReplaceRef.current;
      if (!newReportId) {
        if (showModal) {
          setErrorModalTitle('Erro ao Salvar');
          setErrorMessage('Relatório foi criado mas não foi possível obter o ID. As regras de acréscimo não foram atualizadas.');
          setShowErrorModal(true);
        }
        resetForm();
        setShowModal(false);
        await loadData(getFilterParams());
        return;
      }
      if (toReplace.length > 0) {
        for (const ruleId of toReplace) {
          try {
            await faturamentoService.replaceAccrualReportReference({ rule_id: ruleId, new_report_id: newReportId });
            replaceSuccess++;
          } catch (e) {
            replaceFail++;
            console.error(`Erro ao substituir regra ${ruleId}:`, e?.response?.data?.error || e?.message || e);
          }
        }
      }
      if (replaceFail > 0) {
        setMessage({ type: 'warning', text: `Relatório cadastrado. ${replaceSuccess} regra(s) atualizada(s), ${replaceFail} falha(s).` });
      } else {
        setMessage({ type: 'success', text: `Relatório cadastrado e ${replaceSuccess} regra(s) de acréscimo atualizada(s).` });
      }
      resetForm();
      setShowModal(false);
      await loadData(getFilterParams());
    } catch (err) {
      const errorMsg = err.response?.data?.error || err?.message || 'Erro ao salvar relatório';
      setErrorModalTitle('Erro ao Salvar');
      setErrorMessage(errorMsg);
      setShowErrorModal(true);
    } finally {
      setSaving(false);
      hideProcessing();
      pendingAccrualPayloadRef.current = null;
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setMessage(null);

    // Edit mode - single goal
    if (form.id) {
      const payload = {
        name: form.name.trim(),
        goal_id: parseInt(form.goal_ids[0], 10),
        period_start: form.period_start,
        period_end: form.period_end,
        status: form.status
      };
      await saveReport(payload, true);
      return;
    }

    // New report(s) - validate at least one goal selected
    if (!form.goal_ids || form.goal_ids.length === 0) {
      setErrorModalTitle('Erro de Validação');
      setErrorMessage('Selecione ao menos uma meta.');
      setShowErrorModal(true);
      return;
    }

    // Single goal - use existing flow with accrual check
    if (form.goal_ids.length === 1) {
      const payload = {
        name: form.name.trim() || generateReportNameFromGoal(form.goal_ids[0]),
        goal_id: parseInt(form.goal_ids[0], 10),
        period_start: form.period_start,
        period_end: form.period_end,
        status: form.status
      };

      try {
        const checkRes = await faturamentoService.checkAccrualReports({
          goal_id: parseInt(form.goal_ids[0], 10)
        });
        const rules = checkRes?.data?.rules || [];
        if (rules.length > 0) {
          const allRuleIds = rules.map(r => r.rule_id);
          setAccrualRules(rules);
          setAccrualRulesToReplace(allRuleIds);
          accrualRulesToReplaceRef.current = allRuleIds;
          pendingAccrualPayloadRef.current = payload;
          setShowAccrualModal(true);
          return;
        }
      } catch (e) {
        console.error('Erro ao verificar regras de acréscimo:', e);
      }

      await saveReport(payload, false);
      return;
    }

    // Multiple goals - create one report per goal with the same period
    showProcessing('Salvando relatórios...');
    let successCount = 0;
    let errorCount = 0;

    for (const goalId of form.goal_ids) {
      try {
        const createRes = await faturamentoService.createReport({
          name: form.name.trim() || generateReportNameFromGoal(goalId),
          goal_id: parseInt(goalId, 10),
          period_start: form.period_start,
          period_end: form.period_end,
          status: form.status
        });
        if (createRes?.data?.report?.id) successCount++;
        else errorCount++;
      } catch (err) {
        errorCount++;
        console.error(`Erro ao criar relatório para meta ${goalId}:`, err?.response?.data?.error || err?.message || err);
      }
    }

    hideProcessing();

    if (errorCount === 0) {
      setMessage({ type: 'success', text: `${successCount} relatório(s) cadastrado(s) com sucesso.` });
    } else {
      setMessage({ type: 'warning', text: `${successCount} relatório(s) cadastrado(s), ${errorCount} falha(s).` });
    }

    resetForm();
    setShowModal(false);
    await loadData(getFilterParams());
  };

  const remove = async (id) => {
    const report = reports.find(r => r.id === id);
    setReportToDelete(report);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!reportToDelete) return;
    if (reportToDelete.finalized_at && !isAdmin) {
      setMessage({ type: 'danger', text: 'Relatório finalizado não pode ser excluído.' });
      setShowDeleteModal(false);
      setReportToDelete(null);
      return;
    }
    showProcessing('Excluindo relatório...');
    setDeleting(true);
    try {
      await faturamentoService.deleteReport(reportToDelete.id);
      setMessage({ type: 'success', text: 'Relatório removido com sucesso!' });
      setShowDeleteModal(false);
      setReportToDelete(null);
      if (form.id === reportToDelete.id) {
        resetForm();
        setShowModal(false);
      }
      await loadData(getFilterParams());
    } catch (e) {
      const errorMsg = e.response?.data?.error || 'Erro ao remover relatório';
      setErrorModalTitle('Erro ao Remover');
      setErrorMessage(errorMsg);
      setShowErrorModal(true);
    } finally {
      setDeleting(false);
      hideProcessing();
    }
  };

  const reprocessReport = async (id) => {
    const report = reports.find(r => r.id === id);
    setReportToReprocess(report);
    setShowReprocessModal(true);
  };

  const finalizeReport = async (id) => {
    const report = reports.find(r => r.id === id);
    setReportToFinalize(report);
    setShowFinalizeModal(true);
  };

  const confirmFinalize = async () => {
    if (!reportToFinalize) return;
    showProcessing('Finalizando relatório...');
    setFinalizing(true);
    try {
      await faturamentoService.finalizeReport(reportToFinalize.id);
      setMessage({ type: 'success', text: 'Relatório finalizado com sucesso!' });
      setShowFinalizeModal(false);
      setReportToFinalize(null);
      await loadData(getFilterParams());
    } catch (e) {
      const errorMsg = e.response?.data?.error || 'Erro ao finalizar relatório';
      setErrorModalTitle('Erro ao Finalizar');
      setErrorMessage(errorMsg);
      setShowErrorModal(true);
    } finally {
      setFinalizing(false);
      hideProcessing();
    }
  };

  const confirmBulkFinalize = async () => {
    showProcessing('Finalizando lote de relatórios...');
    setBulkFinalizing(true);
    try {
      await faturamentoService.bulkFinalizeReports(selectedReportIds);
      setMessage({ type: 'success', text: `${selectedReportIds.length} relatórios finalizados com sucesso.` });
      setShowBulkFinalizeModal(false);
      setSelectedReportIds([]);
      await loadData(getFilterParams());
    } catch (e) {
      setMessage({ type: 'danger', text: 'Erro ao finalizar lote de relatórios.' });
    } finally {
      setBulkFinalizing(false);
      hideProcessing();
    }
  };

  const confirmReprocess = async () => {
    if (!reportToReprocess) return;
    if (reportToReprocess.finalized_at && !isAdmin) {
      setMessage({ type: 'danger', text: 'Relatório finalizado não pode ser reprocessado.' });
      setShowReprocessModal(false);
      setReportToReprocess(null);
      return;
    }
    showProcessing('Reprocessando relatório...');
    setReprocessing(true);
    try {
      await faturamentoService.reprocessReport(reportToReprocess.id);
      setMessage({ type: 'success', text: 'Relatório enviado para reprocessamento com sucesso!' });
      setShowReprocessModal(false);
      setReportToReprocess(null);
      await loadData(getFilterParams());
    } catch (e) {
      const errorMsg = e.response?.data?.error || 'Erro ao reprocessar relatório';
      setErrorModalTitle('Erro ao Reprocessar');
      setErrorMessage(errorMsg);
      setShowErrorModal(true);
    } finally {
      setReprocessing(false);
      hideProcessing();
    }
  };

  const confirmBulkReprocess = async () => {
    showProcessing('Reprocessando lote de relatórios...');
    setBulkReprocessing(true);
    let successCount = 0;
    let errorCount = 0;
    const validIds = selectedReportIds.filter(id => {
      const report = reports.find(r => Number(r.id) === Number(id));
      return !report || (!report.finalized_at || isAdmin);
    });

    try {
      for (const id of validIds) {
        try {
          await faturamentoService.reprocessReport(id);
          successCount++;
        } catch (e) {
          console.error(`Erro ao reprocessar relatório ${id}:`, e);
          errorCount++;
        }
      }

      if (errorCount === 0) {
        setMessage({ type: 'success', text: `${successCount} relatórios enviados para reprocessamento.` });
      } else {
        setMessage({ type: 'warning', text: `${successCount} relatórios enviados, ${errorCount} falharam.` });
      }
      
      setShowBulkReprocessModal(false);
      setSelectedReportIds([]);
      await loadData(getFilterParams());
    } catch (e) {
      setMessage({ type: 'danger', text: 'Erro ao processar lote de relatórios.' });
    } finally {
      setBulkReprocessing(false);
      hideProcessing();
    }
  };

  const confirmBulkDelete = async () => {
    showProcessing('Excluindo lote de relatórios...');
    setBulkDeleting(true);
    let successCount = 0;
    let errorCount = 0;
    const validIds = selectedReportIds.filter(id => {
      const report = reports.find(r => Number(r.id) === Number(id));
      return !report || (!report.finalized_at || isAdmin);
    });

    try {
      for (const id of validIds) {
        try {
          await faturamentoService.deleteReport(id);
          successCount++;
        } catch (e) {
          console.error(`Erro ao excluir relatório ${id}:`, e);
          errorCount++;
        }
      }

      if (errorCount === 0) {
        setMessage({ type: 'success', text: `${successCount} relatórios excluídos com sucesso.` });
      } else {
        setMessage({ type: 'warning', text: `${successCount} relatórios excluídos, ${errorCount} falharam.` });
      }
      
      setShowBulkDeleteModal(false);
      setSelectedReportIds([]);
      await loadData(getFilterParams());
    } catch (e) {
      setMessage({ type: 'danger', text: 'Erro ao excluir lote de relatórios.' });
    } finally {
      setBulkDeleting(false);
      hideProcessing();
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    if (!form.id) resetForm();
  };

  const toggleSelectReport = (reportId) => {
    setSelectedReportIds((prev) =>
      prev.includes(reportId) ? prev.filter((id) => id !== reportId) : [...prev, reportId]
    );
  };

  const toggleSelectAllReports = () => {
    if (selectedReportIds.length === reports.length) {
      setSelectedReportIds([]);
      return;
    }
    setSelectedReportIds(reports.map((r) => Number(r.id)));
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    const params = getFilterParams();
    params.page = newPage;
    loadData(params);
  };

  const handlePerPageChange = (newPerPage) => {
    setPerPage(newPerPage);
    setPage(1);
    const params = getFilterParams();
    params.page = 1;
    params.per_page = newPerPage;
    loadData(params);
  };

  const totalPages = Math.ceil(totalRecords / perPage) || 1;

  const showProcessing = (msg) => {
    setProcessingMessage(msg);
    setShowProcessingModal(true);
  };

  const hideProcessing = () => {
    setShowProcessingModal(false);
  };

  const exportSelectedReports = async () => {
    if (selectedReportIds.length === 0) {
      setMessage({ type: 'warning', text: 'Selecione ao menos um relatório para exportar.' });
      return;
    }
    showProcessing('Exportando relatórios...');
    try {
      const response = await faturamentoService.exportReportsExcel(selectedReportIds);
      const contentType = response.headers?.['content-type'] || '';
      if (contentType.includes('application/json')) {
        const text = await response.data.text();
        const parsed = JSON.parse(text);
        throw new Error(parsed?.error || 'Erro ao exportar relatórios');
      }
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const timestamp = new Date().toISOString().replace(/[-:T]/g, '').slice(0, 14);
      link.setAttribute('download', `relatorios_faturamento_${timestamp}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setMessage({ type: 'success', text: 'Exportação concluída.' });
    } catch (e) {
      setMessage({ type: 'danger', text: e.message || 'Erro ao exportar relatórios' });
    } finally {
      hideProcessing();
    }
  };

  const getGoalTypeLabel = (goalType, goalSubtype, goalClassification) => {
    const typeMap = {
      monthly_revenue: 'Mensal',
      quarterly_revenue: 'Trimestral',
      yearly_revenue: 'Anual',
    };
    const base = typeMap[goalType] || (goalType ? String(goalType).replace(/_/g, ' ') : 'Mensal');

    const parts = [base];

    if (goalSubtype) {
      const subtypeMap = {
        clientes_positivados: 'Clientes Positivados',
        produtos_destaque: 'Produtos Destaque',
        faturamento: 'Faturamento',
      };
      const sub = subtypeMap[goalSubtype] || goalSubtype;
      if (sub) parts.push(sub);
    }

    if (goalClassification && goalClassification !== 'vendedor') {
      const classMap = {
        bijou: 'Bijou',
        operador_caixa: 'Operador de Caixa',
      };
      const cls = classMap[goalClassification] || goalClassification;
      if (cls) parts.push(cls);
    }

    return parts.join(' - ');
  };

  const goalLabel = (g) => {
    if (!g) return '';
    const typeDesc = getGoalTypeLabel(g.goal_type, g.goal_subtype, g.goal_classification);
    const isQty = ['clientes_positivados', 'produtos_destaque'].includes(g.goal_subtype);
    const target = isQty ? `${g.target_quantity || 0} un` : `R$ ${Number(g.target_amount || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;
    const name = g.vendor_name || g.employee_name || (g.branch_name ? `Filial: ${g.branch_name}` : (g.branch_code ? `Filial ${g.branch_code}` : 'Meta Geral'));
    const period = g.reference_month ? `${g.reference_month}/${g.reference_year || '-'}` : (g.reference_year || '-');
    return `[${typeDesc}] ${name} - ${period} (${target})`;
  };

  const isGoalWithReport = useCallback((g) => {
    if (!g) return false;
    if (g.has_report) return true;
    const gId = Number(g.id);
    return allReports.some(r => Number(r.goal_id) === gId);
  }, [allReports]);

  const getGoalNotes = (report) => {
    if (!report?.goal_id) return '';
    const goal = goals.find(g => Number(g.id) === Number(report.goal_id));
    return goal?.notes || '';
  };

  const filteredModalGoals = goals.filter(g => {
    if (modalBranchFilter.length > 0) {
      const vendorBranch = g.vendor_id ? (vendorBranchMap[String(g.vendor_id)] || g.vendor_codfilial || '') : '';
      const employeeBranch = g.employee_codfilial || '';
      const goalBranch = g.branch_code ? String(g.branch_code) : '';
      const effectiveBranch = goalBranch || vendorBranch || employeeBranch || '';

      let matchesBranch = false;
      if (effectiveBranch) {
        matchesBranch = modalBranchFilter.some(branchId =>
          effectiveBranch.split(',').some(code => code.trim() === String(branchId).trim())
        );
      }
      if (!matchesBranch) return false;
    }
    if (modalGoalYear && String(g.reference_year) !== modalGoalYear) return false;
    if (modalGoalMonth && String(g.reference_month) !== modalGoalMonth) return false;
    return true;
  });

const generateReportNameFromGoal = (goalId) => {
  if (!goalId) return '';
  
  const goal = goals.find(g => g.id === parseInt(goalId));
  if (!goal) return '';
  
  const vendorName = goal.vendor_name || goal.employee_name || (goal.branch_name ? goal.branch_name : (goal.branch_code ? `Filial ${goal.branch_code}` : 'Geral'));
  let goalType = goal.goal_type === 'monthly_revenue' ? 'Mensal' : 
                 goal.goal_type === 'quarterly_revenue' ? 'Trimestral' : 'Anual';
  if (goal.goal_subtype === 'clientes_positivados') goalType += ' (Clientes Positivados)';
  else if (goal.goal_subtype === 'produtos_destaque') goalType += ' (Produtos Destaque)';
  const period = goal.reference_month ? `${goal.reference_month}/${goal.reference_year}` : goal.reference_year;
  
  return `Relatório ${goalType} - ${vendorName} - ${period}`;
};

  const isDirectGoalFilter = (f, report) => {
    if (f.is_direct_goal_filter !== undefined && f.is_direct_goal_filter !== null) {
      return Boolean(Number(f.is_direct_goal_filter));
    }
    if (f.is_variable_placeholder !== undefined && f.is_variable_placeholder !== null) {
      return !Boolean(Number(f.is_variable_placeholder));
    }
    if (report?.processed_data?.calculations?.length > 0) {
      const isUsedInVar = report.processed_data.calculations.some(c => {
        let details = c.calculation_details;
        if (typeof details === 'string') {
          try { details = JSON.parse(details); } catch (e) { details = {}; }
        }
        return (details?.placeholders || []).some(ph =>
          Number(ph.filter_id) === Number(f.filter_id) ||
          (ph.dep_placeholders || []).some(dph => Number(dph.filter_id) === Number(f.filter_id))
        );
      });
      if (isUsedInVar) {
        return false;
      }
    }
    return true;
  };

  const getDirectReportFilters = (report) => {
    const list = report?.processed_data?.by_filter;
    if (!Array.isArray(list) || list.length === 0) return [];
    return list.filter(f => isDirectGoalFilter(f, report));
  };

  const getVariablesTotal = (report) => Number(report?.processed_data?.totals?.variables_total || 0);
  const getFiltersTotal = (report) => {
    return getDirectReportFilters(report).reduce((sum, f) => sum + Number(f.total_net || 0), 0);
  };
  const getFiltersGrossTotal = (report) => {
    return getDirectReportFilters(report).reduce((sum, f) => sum + Number(f.total_gross || 0), 0);
  };
  const getFiltersReturnsTotal = (report) => {
    return getDirectReportFilters(report).reduce((sum, f) => sum + Number(f.total_returns || f.total_discount || 0), 0);
  };
  const hasFilterBreakdown = (report) => getDirectReportFilters(report).length > 0;
  const isVariableOnlyContext = (report) => {
    if (report?.processed_data?.totals?.is_variable_only !== undefined) {
      return Boolean(report.processed_data.totals.is_variable_only);
    }
    const hasDirectFilters = getDirectReportFilters(report).some(
      f => (f.include_in_goal_total ?? 1) !== 0
    );
    const hasCalculations = (report?.processed_data?.calculations?.length || 0) > 0;
    if (!hasDirectFilters && hasCalculations) return true;
    return !hasFilterBreakdown(report) && hasCalculations;
  };
  const getTotalOrders = (report) => {
    if (report?.goal_subtype === 'produtos_destaque') {
      return Number(report?.processed_data?.totals?.total_quantity ?? report?.total_quantity ?? report?.processed_data?.totals?.total_orders ?? report?.total_orders ?? 0);
    }
    if (hasFilterBreakdown(report)) {
      return getDirectReportFilters(report).reduce((sum, f) => sum + Number(f.order_count || 0), 0);
    }
    return Number(report?.processed_data?.totals?.total_orders || 0);
  };
  const getTotalGross = (report) => {
    if (hasFilterBreakdown(report)) {
      return getFiltersGrossTotal(report);
    }
    return Number(report?.processed_data?.totals?.total_gross_revenue || 0);
  };
  const getTotalNet = (report) => {
    if (hasFilterBreakdown(report)) {
      return getFiltersTotal(report);
    }
    return Number(report?.processed_data?.totals?.total_net_revenue || 0);
  };
  const getTotalReturns = (report) => {
    if (hasFilterBreakdown(report)) {
      return getFiltersReturnsTotal(report);
    }
    return Number(getTotalGross(report) - getTotalNet(report));
  };
  const getFinalTotal = (report) => {
    if (report?.processed_data?.totals?.final_total !== undefined) {
      return Number(report.processed_data.totals.final_total);
    }
    if (isVariableOnlyContext(report)) return getVariablesTotal(report);
    return getTotalNet(report) + getVariablesTotal(report);
  };
  const getGoalTotal = (report) => {
    if (report?.goal_subtype === 'produtos_destaque') {
      return Number(report.processed_data?.totals?.total_quantity ?? report.total_quantity ?? 0);
    }
    if (report?.goal_subtype === 'clientes_positivados') {
      return Number(report.processed_data?.totals?.total_orders ?? report.total_orders ?? 0);
    }
    if (!report?.processed_data) return 0;
    if (report.processed_data.totals?.goal_total !== undefined) {
      return Number(report.processed_data.totals.goal_total);
    }
    if (isVariableOnlyContext(report)) {
      let total = 0;
      if (report.processed_data.calculations) {
        for (const c of report.processed_data.calculations) {
          if ((c.include_in_goal_total ?? 1) !== 0) {
            total += Number(c.result || 0);
          }
        }
      }
      return total;
    }
    let total = 0;
    const directFilters = getDirectReportFilters(report);
    for (const f of directFilters) {
      if ((f.include_in_goal_total ?? 1) !== 0) {
        total += Number(f.total_net || 0);
      }
    }
    if (report.processed_data.calculations) {
      for (const c of report.processed_data.calculations) {
        if ((c.include_in_goal_total ?? 1) !== 0) {
          total += Number(c.result || 0);
        }
      }
    }
    return total;
  };

  const isQuantityGoal = (report) => {
    return ['clientes_positivados', 'produtos_destaque'].includes(report?.goal_subtype);
  };
  const getGoalTargetValue = (report) => {
    if (isQuantityGoal(report)) {
      // Primeiro tenta do processed_data (preenchido pelo sincronizador a partir da meta)
      const pdQty = Number(report?.processed_data?.totals?.target_quantity || 0);
      if (pdQty > 0) return pdQty;
      if (report?.target_quantity) return Number(report.target_quantity);
    }
    return Number(report?.target_amount || 0);
  };
  const getAchievedValue = (report) => {
    if (isQuantityGoal(report)) {
      if (report?.goal_subtype === 'clientes_positivados') {
        return Number(report?.processed_data?.totals?.total_orders ?? report?.total_orders ?? 0);
      }
      if (report?.goal_subtype === 'produtos_destaque') {
        return Number(report?.processed_data?.totals?.total_quantity ?? report?.total_quantity ?? 0);
      }
      const directFilters = getDirectReportFilters(report);
      if (directFilters.length > 0) {
        return directFilters.reduce((sum, f) => sum + Number(f.total_quantity || 0), 0);
      }
      return Number(report?.processed_data?.totals?.total_quantity ?? report?.total_quantity ?? 0);
    }
    return getGoalTotal(report);
  };
  const hasExcludedFromGoal = (report) => {
    if (getFinalTotal(report) !== getGoalTotal(report)) return true;
    return false;
  };
  const isFilterCustomForGoal = (phOrFilter, report, goal = null) => {
    if (!phOrFilter) return false;
    const filterId = Number(phOrFilter.filter_id || phOrFilter.id || 0);
    const resolvedGoal = goal || (goals || []).find(g => Number(g.id) === Number(report?.goal_id));
    const goalConfigs = resolvedGoal?.filter_configs || report?.filter_configs || report?.processed_data?.filter_configs;
    const goalConfig = (goalConfigs && filterId > 0) ? (goalConfigs[filterId] || goalConfigs[String(filterId)]) : null;
    if (goalConfig && (goalConfig.is_custom !== undefined ? (Number(goalConfig.is_custom) === 1 || goalConfig.is_custom === true) : true)) {
      return true;
    }
    if (Number(phOrFilter.is_custom_for_goal || phOrFilter.is_custom || 0) === 1) {
      return true;
    }
    const byFilter = report?.processed_data?.by_filter;
    if (Array.isArray(byFilter)) {
      const matched = byFilter.find(f => Number(f.filter_id || f.id) === filterId);
      if (matched && Number(matched.is_custom_for_goal || matched.is_custom || 0) === 1) {
        return true;
      }
    }
    return false;
  };

  const isPlaceholderActive = (ph, report = null) => {
    const qty = Number(ph.filter_sold_qty || 0);
    if (qty <= 0) return false;
    const net = Number(ph.net || 0);
    const filterId = Number(ph.filter_id || ph.id || 0);
    const resolvedGoal = report ? (goals || []).find(g => Number(g.id) === Number(report?.goal_id)) : null;
    const goalConfigs = resolvedGoal?.filter_configs || report?.filter_configs || report?.processed_data?.filter_configs;
    const goalConfig = (goalConfigs && filterId > 0) ? (goalConfigs[filterId] || goalConfigs[String(filterId)]) : null;
    const matchedFilter = report?.processed_data?.by_filter?.find(f => Number(f.filter_id || f.id) === filterId);

    const minQty = Number(goalConfig?.commission_min_products_qty ?? ph.filter_commission_min_products_qty ?? matchedFilter?.commission_min_products_qty ?? 0);
    const minValue = Number(goalConfig?.commission_min_sold_value ?? ph.filter_commission_min_sold_value ?? matchedFilter?.commission_min_sold_value ?? 0);
    const bonusMinQty = Number(goalConfig?.bonus_min_products_qty ?? ph.bonus_min_products_qty ?? matchedFilter?.bonus_min_products_qty ?? 0);
    const bonusMinValue = Number(goalConfig?.bonus_min_sold_value ?? ph.bonus_min_sold_value ?? matchedFilter?.bonus_min_sold_value ?? 0);
    const hasAnyMin = minQty > 0 || minValue > 0 || bonusMinQty > 0 || bonusMinValue > 0;
    if (!hasAnyMin) return true;
    if (minQty > 0 && qty >= minQty) return true;
    if (minValue > 0 && net >= minValue) return true;
    if (bonusMinQty > 0 && qty >= bonusMinQty) return true;
    if (bonusMinValue > 0 && net >= bonusMinValue) return true;
    return false;
  };
  const hasProcessedData = (report) => {
    const totals = report?.processed_data?.totals || {};
    const hasOrders = Number(totals.total_orders || 0) > 0;
    const hasVariables = Number(totals.variables_total || 0) !== 0;
    const hasCalculations = (report?.processed_data?.calculations?.length || 0) > 0;
    const hasFilters = (report?.processed_data?.by_filter?.length || 0) > 0;
    const hasQuantityResult = Number(totals.total_net_revenue || 0) > 0;
    return hasOrders || hasVariables || hasCalculations || hasFilters || hasQuantityResult;
  };

  return (
    <div className="container-fluid py-4">
      <div className="mb-4 d-flex justify-content-between align-items-start flex-wrap gap-3">
        <div>
          <h2 className="mb-1">Relatorios</h2>
          <p className="text-muted mb-0">Cadastro de relatorios para processamento pelo sincronizador (status pendente/processado).</p>
        </div>
        <button
          type="button"
          className="btn-modern btn-modern-light d-flex align-items-center gap-2"
          onClick={() => loadData(getFilterParams(), false, true)}
          disabled={loading}
          title="Atualizar relatórios com os filtros aplicados"
        >
          <FiRefreshCw size={16} className={loading ? 'spin-ico' : ''} />
          <span>Atualizar</span>
        </button>
      </div>

      {message && <div className={`alert alert-${message.type} py-2 mb-4`}>{message.text}</div>}

      {/* Botao Novo Relatorio & Agendar Sincronizacao */}
      <div className="mb-4 d-flex flex-wrap gap-2 align-items-center">
        {canManage && (
          <button type="button" className="btn-modern btn-modern-primary" onClick={openNewModal}>
            <FiPlus size={16} className="me-2" />Novo Relatorio
          </button>
        )}
        <button
          type="button"
          className="btn-modern btn-modern-outline-primary"
          onClick={openSyncScheduleModal}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            borderColor: '#3b82f6',
            color: '#2563eb',
            backgroundColor: '#eff6ff',
            fontWeight: 600
          }}
          title="Configurar rotinas automáticas de sincronização de relatórios"
        >
          <FiClock size={16} />
          <span>Agendar Sincronização</span>
          {activeSchedulesCount > 0 && (
            <span
              style={{
                backgroundColor: '#2563eb',
                color: '#ffffff',
                borderRadius: '999px',
                padding: '1px 8px',
                fontSize: '0.72rem',
                fontWeight: 700,
                lineHeight: 1.4
              }}
            >
              {activeSchedulesCount}
            </span>
          )}
        </button>
      </div>

      {/* Painel de Filtros Padronizado no Estilo BI */}
      <div className="bi-toolbar mb-4" style={{ overflow: 'visible', position: 'relative', zIndex: 30 }}>
        <div className="bi-filters-left">
          {/* Status */}
          <div style={{ minWidth: '150px' }}>
            <MultiSelectSearch
              label="Status"
              placeholder="Buscar..."
              value={filters.status}
              onChange={(selected) => setFilters({ ...filters, status: selected })}
              options={[
                { id: 'draft', label: 'Pendente' },
                { id: 'processing', label: 'Processando' },
                { id: 'completed', label: 'Processado' },
                { id: 'failed', label: 'Falhou' }
              ]}
              badgeColor="#3b82f6"
              getOptionLabel={(opt) => opt.label}
              getOptionValue={(opt) => opt.id}
            />
          </div>

          {/* Filial */}
          <div style={{ minWidth: '160px' }}>
            <MultiSelectSearch
              label="Filial"
              placeholder="Buscar filial..."
              value={filters.branch_ids}
              onChange={(selected) => setFilters({ ...filters, branch_ids: selected })}
              options={branches}
              badgeColor="#f59e0b"
              getOptionLabel={(opt) => opt.label}
              getOptionValue={(opt) => opt.id}
            />
          </div>

          {/* Vendedor */}
          <div style={{ minWidth: '170px' }}>
            <MultiSelectSearch
              label="Vendedor"
              placeholder="Buscar vendedor..."
              value={filters.vendor_ids}
              onChange={(selected) => setFilters({ ...filters, vendor_ids: selected })}
              options={filteredVendors.map(v => ({ id: v.id, label: v.nome }))}
              badgeColor="#10b981"
              getOptionLabel={(opt) => opt.label}
              getOptionValue={(opt) => opt.id}
            />
          </div>

          {/* Funcionário */}
          <div style={{ minWidth: '170px' }}>
            <MultiSelectSearch
              label="Funcionário"
              placeholder="Buscar funcionário..."
              value={filters.employee_ids}
              onChange={(selected) => setFilters({ ...filters, employee_ids: selected })}
              options={filteredEmployees.map(e => ({ id: e.id, label: e.nome }))}
              badgeColor="#8b5cf6"
              getOptionLabel={(opt) => opt.label}
              getOptionValue={(opt) => opt.id}
            />
          </div>

          {/* Meta */}
          <div style={{ minWidth: '180px' }}>
            <MultiSelectSearch
              label="Meta"
              placeholder="Buscar meta..."
              value={filters.goal_ids}
              onChange={(selected) => setFilters({ ...filters, goal_ids: selected })}
              options={goals.map(g => ({
                id: g.id,
                label: goalLabel(g)
              }))}
              badgeColor="#6f42c1"
              getOptionLabel={(opt) => opt.label}
              getOptionValue={(opt) => opt.id}
            />
          </div>

          {/* Finalizado */}
          <BIFilterSelect
            label="Finalizado"
            value={filters.finalized}
            onChange={(val) => setFilters({ ...filters, finalized: val })}
            options={[
              { value: 'no', label: 'Não' },
              { value: 'yes', label: 'Sim' }
            ]}
            allLabel="Todos"
            minWidth="120px"
          />

          {/* Alvo */}
          <BIFilterSelect
            label="Alvo"
            value={filters.target_type || ''}
            onChange={(val) => setFilters({ ...filters, target_type: val })}
            options={[
              { value: 'vendor', label: 'Vendedor' },
              { value: 'employee', label: 'Funcionário' },
              { value: 'branch', label: 'Filial' },
              { value: 'general', label: 'Geral' }
            ]}
            allLabel="Todos os Alvos"
            minWidth="145px"
          />

          {/* Tipo */}
          <BIFilterSelect
            label="Tipo"
            value={filters.goal_type || ''}
            onChange={(val) => setFilters({ ...filters, goal_type: val })}
            options={[
              { value: 'monthly_revenue', label: 'Mensal' },
              { value: 'quarterly_revenue', label: 'Trimestral' },
              { value: 'yearly_revenue', label: 'Anual' },
              { value: 'clientes_positivados', label: 'Clientes Positivados' },
              { value: 'produtos_destaque', label: 'Produtos Destaque' }
            ]}
            allLabel="Todos os Tipos"
            minWidth="155px"
          />

          {/* Classificação */}
          <BIFilterSelect
            label="Classificação"
            value={filters.goal_classification || ''}
            onChange={(val) => setFilters({ ...filters, goal_classification: val })}
            options={[
              { value: 'vendedor', label: 'Vendedor' },
              { value: 'bijou', label: 'Bijou' },
              { value: 'operador_caixa', label: 'Operador de Caixa' }
            ]}
            allLabel="Todas as Classificações"
            minWidth="155px"
          />

          {/* Período no formato BI */}
          <BIPeriodFilter
            startDate={filters.period_start}
            endDate={filters.period_end}
            onChange={(start, end) => setFilters({ ...filters, period_start: start, period_end: end })}
            label="Início / Fim"
            minWidth="195px"
          />

          {/* Buscar */}
          <div className="bi-filter-item" style={{ flex: 1, minWidth: '220px' }}>
            <span className="bi-filter-label">Buscar</span>
            <div className="bi-search-input-wrapper position-relative">
              <FiSearch
                size={15}
                style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#64748b', zIndex: 2, pointerEvents: 'none' }}
              />
              <input
                type="text"
                className="form-control-modern bi-input w-100"
                placeholder="Buscar por nome, vendedor, período..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    applyFilters();
                  }
                }}
                style={{ paddingLeft: '40px', paddingRight: searchTerm ? '32px' : '12px' }}
              />
              {searchTerm && (
                <button
                  type="button"
                  className="bi-search-clear-btn"
                  onClick={() => {
                    setSearchTerm('');
                    setPage(1);
                    loadData(buildFilterParams(filters, '', 1));
                  }}
                  title="Limpar busca"
                >
                  <FiX size={14} />
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Barra de Ações */}
        <div className="d-flex align-items-center gap-2 mt-3 pt-2 border-top w-100">
          <button type="button" className="btn btn-primary d-flex align-items-center gap-2 px-3" style={{ height: '38px', borderRadius: '8px', fontWeight: 600, fontSize: '0.84rem' }} onClick={applyFilters}>
            <FiSearch size={14} /> Aplicar Filtros
          </button>
          <button type="button" className="btn btn-light border d-flex align-items-center gap-2 px-3" style={{ height: '38px', borderRadius: '8px', fontWeight: 600, fontSize: '0.84rem', color: '#475569', backgroundColor: '#f8fafc' }} onClick={clearFilters}>
            <FiX size={14} /> Limpar
          </button>
        </div>
      </div>

      {/* Listagem de Relatorios */}
      <div className="settings-container" style={{ position: 'relative', zIndex: 1 }}>
        <div className="card-modern shadow-sm-modern">
          <div className="card-header-modern bg-transparent border-0 pt-4 px-4 pb-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
            <div>
              <h5 className="mb-0 fw-bold text-dark">Relatorios cadastrados</h5>
              <p className="text-muted small mb-0">Pendentes sao consumidos pelo sincronizador</p>
            </div>
            
            {selectedReportIds.length > 0 && (
              <div className="d-flex gap-2 animate__animated animate__fadeIn">
                <button
                  type="button"
                  className="btn-modern btn-modern-light btn-modern-sm"
                  onClick={exportSelectedReports}
                  title="Exportar selecionados para Excel"
                >
                  <FiDownload size={14} className="me-1" />
                  Exportar ({selectedReportIds.length})
                </button>
                <button
                  type="button"
                  className="btn-modern btn-modern-success btn-modern-sm"
                  onClick={() => setShowBulkFinalizeModal(true)}
                  title="Finalizar selecionados"
                >
                  <FiLock size={14} className="me-1" />
                  Finalizar ({selectedReportIds.length})
                </button>
                {canManage && (
                  <>
                    <button
                      type="button"
                      className="btn-modern btn-modern-warning btn-modern-sm"
                      onClick={() => setShowBulkReprocessModal(true)}
                      title="Reiniciar processamento dos selecionados"
                    >
                      <FiRefreshCw size={14} className="me-1" />
                      Reiniciar ({selectedReportIds.length})
                    </button>
                    <button
                      type="button"
                      className="btn-modern btn-modern-light-danger btn-modern-sm"
                      onClick={() => setShowBulkDeleteModal(true)}
                      title="Excluir selecionados"
                    >
                      <FiTrash2 size={14} className="me-1" />
                      Excluir ({selectedReportIds.length})
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
          <div className="card-body-modern p-4 pt-0" style={{ position: 'relative' }}>
            {loading && reports.length > 0 && (
              <Loading.Overlay text="Atualizando relatórios..." size="sm" />
            )}
            <div className="table-responsive">
              <table className="table-modern w-100">
                <thead>
                  <tr>
                    <th style={{ width: '36px' }}>
                      <input
                        type="checkbox"
                        checked={reports.length > 0 && selectedReportIds.length === reports.length}
                        onChange={toggleSelectAllReports}
                      />
                    </th>
                    <th className="sortable-header" onClick={() => handleSort('name')}>
                      Relatório{renderSortIcon('name')}
                    </th>
                    <th className="sortable-header" style={{ minWidth: '130px' }} onClick={() => handleSort('branch')}>
                      Filial{renderSortIcon('branch')}
                    </th>
                    <th className="sortable-header" onClick={() => handleSort('meta')}>
                      Meta{renderSortIcon('meta')}
                    </th>
                    <th className="sortable-header" onClick={() => handleSort('period')}>
                      Período{renderSortIcon('period')}
                    </th>
                    <th className="sortable-header" onClick={() => handleSort('status')}>
                      Status{renderSortIcon('status')}
                    </th>
                    <th className="text-end">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {loading && reports.length === 0 ? (
                    <Loading.Table
                      colSpan={7}
                      text="Carregando relatórios de fechamento..."
                      subtext="Consolidando dados de faturamento, variáveis e regras de comissão..."
                    />
                  ) : reports.length === 0 ? (
                    <tr>
                      <td colSpan={7} className="text-center py-5 text-muted small">
                        Nenhum relatório cadastrado.
                      </td>
                    </tr>
                  ) : (
                    reports.map((r) => (
                    <React.Fragment key={r.id}>
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedReportIds.includes(Number(r.id))}
                            onChange={() => toggleSelectReport(Number(r.id))}
                          />
                        </td>
                        <td>
                          <div className="fw-medium">{r.name}</div>
                          <small className="text-muted">ID {r.id}</small>
                          {getGoalNotes(r) && (
                            <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '220px' }} title={getGoalNotes(r)}>
                              <small className="text-muted">{getGoalNotes(r)}</small>
                            </div>
                          )}
                        </td>
                        <td>
                          {resolveReportBranchBadge(r)}
                        </td>
                        <td>
                          <div><small className="fw-medium">{r.vendor_name || r.employee_name || (r.preset_name ? <span className="text-primary fw-semibold">{r.preset_name}</span> : (r.branch_name ? <span className="text-primary fw-semibold">{r.branch_name}</span> : 'Meta Geral / Loja'))}</small></div>
                          <div className="d-flex align-items-center gap-1 mt-1 flex-wrap">
                            <span className="badge-modern badge-modern-secondary" style={{ fontSize: '0.65rem' }}>
                              {getGoalTypeLabel(r.goal_type, r.goal_subtype)}
                            </span>
                            {r.target_type && (
                              <span style={{
                                fontSize: '0.65rem', padding: '1px 7px', borderRadius: '10px',
                                fontWeight: 600,
                                backgroundColor: r.target_type === 'employee' ? '#f5f3ff' : (r.target_type === 'branch' ? '#fef3c7' : (r.target_type === 'general' ? '#f1f5f9' : '#ecfdf5')),
                                color: r.target_type === 'employee' ? '#7c3aed' : (r.target_type === 'branch' ? '#d97706' : (r.target_type === 'general' ? '#475569' : '#059669')),
                                border: `1px solid ${r.target_type === 'employee' ? '#ddd6fe' : (r.target_type === 'branch' ? '#fde68a' : (r.target_type === 'general' ? '#cbd5e1' : '#a7f3d0'))}`
                              }}>
                                {r.target_type === 'employee' ? 'Funcionário' : (r.target_type === 'branch' ? 'Filial' : (r.target_type === 'general' ? 'Geral' : 'Vendedor'))}
                              </span>
                            )}
                            {r.goal_classification && (
                              <span style={{
                                fontSize: '0.65rem', padding: '1px 7px', borderRadius: '10px',
                                fontWeight: 600,
                                backgroundColor: r.goal_classification === 'bijou' ? '#fdf2f8' : (r.goal_classification === 'operador_caixa' ? '#fffbeb' : '#eff6ff'),
                                color: r.goal_classification === 'bijou' ? '#db2777' : (r.goal_classification === 'operador_caixa' ? '#d97706' : '#2563eb'),
                                border: `1px solid ${r.goal_classification === 'bijou' ? '#fbcfe8' : (r.goal_classification === 'operador_caixa' ? '#fde68a' : '#bfdbfe')}`
                              }}>
                                {r.goal_classification === 'bijou' ? 'Bijou' : (r.goal_classification === 'operador_caixa' ? 'Operador de Caixa' : 'Vendedor')}
                              </span>
                            )}
                          </div>
                        </td>
                        <td>{String(r.period_start).slice(0, 10)} ate {String(r.period_end).slice(0, 10)}</td>
                        <td>
                          {r.finalized_at ? (
                            <span className="badge-modern badge-modern-info">Finalizado</span>
                          ) : (
                            <span className={`badge-modern ${r.status === 'completed' ? 'badge-modern-success' : r.status === 'failed' ? 'badge-modern-danger' : 'badge-modern-secondary'}`}>{({ draft: 'Pendente', processing: 'Processando', completed: 'Processado', failed: 'Falhou' }[r.status] || r.status)}</span>
                          )}
                        </td>
                        <td className="text-end text-nowrap">
                          <button
                            type="button"
                            className="btn-modern btn-modern-light btn-modern-sm me-1"
                            onClick={() => toggleExpand(r.id)}
                            title={expandedReportId === r.id ? 'Recolher' : 'Expandir'}
                          >
                            {expandedReportId === r.id ? <FiChevronUp size={14} /> : <FiChevronDown size={14} />}
                          </button>
                          <button type="button" className="btn-modern btn-modern-light btn-modern-sm me-1" onClick={() => edit(r)} title="Editar"><FiEdit2 size={14} /></button>
                          {!r.finalized_at && (
                            <button 
                              type="button" 
                              className="btn-modern btn-modern-success btn-modern-sm me-1" 
                              onClick={() => finalizeReport(r.id)} 
                              title="Finalizar"
                            >
                              <FiLock size={14} />
                            </button>
                          )}
                          {canManage && (
                            <>
                              <button 
                                type="button" 
                                className="btn-modern btn-modern-warning btn-modern-sm me-1" 
                                onClick={() => reprocessReport(r.id)} 
                                title={r.finalized_at && !isAdmin ? 'Finalizado' : 'Reprocessar'}
                                disabled={r.status === 'processing' || (!!r.finalized_at && !isAdmin)}
                              >
                                <FiRefreshCw size={14} />
                              </button>
                              <button type="button" className="btn-modern btn-modern-light-danger btn-modern-sm" onClick={() => remove(r.id)} title={r.finalized_at && !isAdmin ? 'Finalizado' : 'Excluir'} disabled={!!r.finalized_at && !isAdmin}><FiTrash2 size={14} /></button>
                            </>
                          )}
                        </td>
                      </tr>
                      {expandedReportId === r.id && (
                        <tr>
                          <td colSpan="7" className="p-0">
                            <div className="bg-light border-top" style={{ padding: '16px 20px', overflowX: 'auto', maxWidth: '100%' }}>
                              <h6 className="mb-3 text-dark fw-semibold">Valores Obtidos do Sincronizador</h6>
                              <div className="row g-3 mb-3">
                                <div className="col-md-6">
                                  <div className="bg-white p-3 rounded border" style={{ borderLeft: '4px solid var(--primary)' }}>
                                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.7rem', fontWeight: 600, textTransform: 'uppercase' }}>{r.vendor_name ? 'Vendedor' : (r.employee_name ? 'Funcionário' : 'Beneficiário / Meta')}</small>
                                    <div className="fw-semibold text-dark mt-1">{r.vendor_name || r.employee_name || (r.preset_name || (r.branch_name ? r.branch_name : 'Meta Geral'))}</div>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="bg-white p-3 rounded border" style={{ borderLeft: '4px solid #f59e0b' }}>
                                    <small className="text-muted d-block mb-1" style={{ fontSize: '0.7rem', fontWeight: 600, textTransform: 'uppercase' }}>Filial Vinculada</small>
                                    <div className="mt-1 d-flex align-items-center gap-2">
                                      {resolveReportBranchBadge(r)}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {hasProcessedData(r) ? (
                                (() => {
                                  const directFilters = getDirectReportFilters(r);
                                  return (
                                    <>
                                  {/* Progresso da Meta */}
                                  {getGoalTargetValue(r) > 0 && (
                                    <div className="mb-4">
                                      <div className="bg-white p-3 rounded border" style={{ borderLeft: '4px solid #6f42c1' }}>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                          <small className="text-muted text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 600 }}>
                                            Progresso da Meta
                                          </small>
                                          <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                                            {r.goal_type === 'monthly_revenue' ? 'Mensal' : r.goal_type === 'quarterly_revenue' ? 'Trimestral' : 'Anual'}
                                            {r.reference_month && ` - ${r.reference_month}/${r.reference_year}`}
                                          </small>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-end mb-2">
                                          <div>
                                            <div className="fw-bold text-dark" style={{ fontSize: '1.1rem' }}>
                                              {isQuantityGoal(r) ? formatNumber(getAchievedValue(r)) : formatCurrency(getAchievedValue(r))}
                                            </div>
                                            <small className="text-muted">{isQuantityGoal(r) ? `de ${formatNumber(getGoalTargetValue(r))} ${r.goal_subtype === 'clientes_positivados' ? 'cli' : 'un'}` : `de ${formatCurrency(getGoalTargetValue(r))}`}</small>
                                          </div>
                                          <div className="text-end">
                                            <div className="fw-bold" style={{ fontSize: '1.2rem', color: Math.min((getAchievedValue(r) / getGoalTargetValue(r)) * 100, 100) >= 100 ? '#28a745' : '#6f42c1' }}>
                                              {Math.min(((getAchievedValue(r) / getGoalTargetValue(r)) * 100), 100).toFixed(1)}%
                                            </div>
                                            <small className="text-muted">
                                              {getAchievedValue(r) >= getGoalTargetValue(r) ? 'Meta atingida!' : 'Pendente'}
                                            </small>
                                          </div>
                                        </div>
                                        <div className="progress" style={{ height: '8px' }}>
                                          <div
                                            className="progress-bar"
                                            role="progressbar"
                                            style={{
                                              width: `${Math.min((getAchievedValue(r) / getGoalTargetValue(r)) * 100, 100)}%`,
                                              backgroundColor: getAchievedValue(r) >= getGoalTargetValue(r) ? '#28a745' : '#6f42c1'
                                            }}
                                          />
                                        </div>
                                        {!isQuantityGoal(r) && (
                                          <small className="text-muted d-block mt-2">
                                            {isVariableOnlyContext(r)
                                              ? `Base: Variaveis (${formatCurrency(getVariablesTotal(r))}) = ${formatCurrency(getFinalTotal(r))}`
                                              : `Base: Liquido (${formatCurrency(getTotalNet(r))}) + Variaveis (${formatCurrency(getVariablesTotal(r))}) = ${formatCurrency(getFinalTotal(r))}`
                                            }

                                            {(() => {
                                              const finalTotal = getFinalTotal(r);
                                              const goalTotal = getGoalTotal(r);
                                              const diff = finalTotal - goalTotal;
                                              if (diff > 0.01) {
                                                return <span className="ms-2 text-warning">(Itens excluídos: {formatCurrency(diff)})</span>;
                                              }
                                              return null;
                                            })()}
                                          </small>
                                        )}
                                  </div>
                                </div>
                              )}

                              {/* Info Produtos Destaque e Clientes Positivados */}
                              {['produtos_destaque', 'clientes_positivados'].includes(r.goal_subtype) && (
                                <div className="row g-3 mb-4">
                                  <div className="col-md-4 col-sm-6">
                                    <div className="bg-white p-3 rounded border" style={{ borderLeft: '4px solid var(--info)' }}>
                                      <small className="text-muted text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 600 }}>
                                        {r.goal_subtype === 'clientes_positivados' ? 'Valor por Cliente' : 'Valor por Unidade'}
                                      </small>
                                      <div className="fw-bold text-dark mt-1" style={{ fontSize: '1.1rem' }}>
                                        {Number(r.processed_data?.totals?.unit_value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 4 })}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-4 col-sm-6">
                                    <div className="bg-white p-3 rounded border" style={{ borderLeft: '4px solid var(--success)' }}>
                                      <small className="text-muted text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Adicional Configurado</small>
                                      <div className="fw-bold text-dark mt-1" style={{ fontSize: '1.1rem' }}>
                                        {getAchievedValue(r) >= getGoalTargetValue(r)
                                          ? formatCurrency(Number(r.processed_data?.totals?.goal_bonus_amount || 0))
                                          : formatCurrency(0)}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-4 col-sm-6">
                                    <div className="bg-white p-3 rounded border" style={{ borderLeft: '4px solid #fd7e14' }}>
                                      <small className="text-muted text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Adicional Obtido</small>
                                      <div className="fw-bold text-dark mt-1" style={{ fontSize: '1.1rem' }}>
                                        {getAchievedValue(r) >= getGoalTargetValue(r)
                                          ? formatCurrency(
                                              Number(r.processed_data?.totals?.bonus_amount || 0) +
                                              (['produtos_destaque', 'clientes_positivados'].includes(r.goal_subtype)
                                                ? Number(r.processed_data?.totals?.filter_commission_goal_total || 0)
                                                : 0)
                                            )
                                          : formatCurrency(0)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* Totais Gerais */}
                              <div className="row g-3 mb-4">
                                    {(getTotalOrders(r) > 0 || getTotalGross(r) > 0 || !isVariableOnlyContext(r)) && (
                                      <>
                                        <div className="col-md-3 col-sm-6">
                                          <div className="bg-white p-3 rounded border" style={{ borderLeft: '4px solid var(--primary)' }}>
                                            <small className="text-muted text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 600 }}>
                                              {r.goal_subtype === 'clientes_positivados' ? 'Clientes Positivados' : r.goal_subtype === 'produtos_destaque' ? 'Unidades Vendidas' : 'Total Pedidos'}
                                            </small>
                                            <div className="fw-bold text-dark mt-1" style={{ fontSize: '1.1rem' }}>
                                              {formatNumber(r.goal_subtype === 'produtos_destaque' ? (r.processed_data?.totals?.total_quantity ?? r.total_quantity ?? getTotalOrders(r)) : getTotalOrders(r))}
                                            </div>
                                          </div>
                                        </div>
                                        {r.goal_subtype !== 'clientes_positivados' && (
                                          <>
                                            <div className="col-md-3 col-sm-6">
                                              <div className="bg-white p-3 rounded border" style={{ borderLeft: '4px solid #28a745' }}>
                                                <small className="text-muted text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Faturamento Bruto</small>
                                                <div className="fw-bold text-dark mt-1" style={{ fontSize: '1.1rem' }}>
                                                  {formatCurrency(getTotalGross(r))}
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                              <div className="bg-white p-3 rounded border" style={{ borderLeft: '4px solid #17a2b8' }}>
                                                <small className="text-muted text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Faturamento Liquido</small>
                                                <div className="fw-bold text-dark mt-1" style={{ fontSize: '1.1rem' }}>
                                                  {formatCurrency(getTotalNet(r))}
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                              <div className="bg-white p-3 rounded border" style={{ borderLeft: '4px solid #dc3545' }}>
                                                <small className="text-muted text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Devolucoes</small>
                                                <div className="fw-bold text-dark mt-1" style={{ fontSize: '1.1rem' }}>
                                                  {formatCurrency(getTotalReturns(r))}
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      </>
                                    )}
                                    {!isQuantityGoal(r) && (
                                      <>
                                        <div className="col-md-3 col-sm-6">
                                          <div className="bg-white p-3 rounded border" style={{ borderLeft: '4px solid #6f42c1' }}>
                                            <small className="text-muted text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Total Variaveis</small>
                                            <div className="fw-bold text-dark mt-1" style={{ fontSize: '1.1rem' }}>
                                              {formatCurrency(Number(r.processed_data.totals?.variables_goal_total || 0))}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-md-3 col-sm-6">
                                          <div className="bg-white p-3 rounded border" style={{ borderLeft: '4px solid #0d6efd' }}>
                                            <small className="text-muted text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Resultado Final</small>
                                            <div className="fw-bold text-dark mt-1" style={{ fontSize: '1.1rem' }}>
                                              {formatCurrency(getGoalTotal(r))}
                                            </div>
                                          </div>
                                        </div>
                                        {!isVariableOnlyContext(r) && directFilters.length > 0 && (
                                          <div className="col-md-3 col-sm-6">
                                            <div className="bg-white p-3 rounded border" style={{ borderLeft: '4px solid #fd7e14' }}>
                                              <small className="text-muted text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Total Filtros</small>
                                              <div className="fw-bold text-dark mt-1" style={{ fontSize: '1.1rem' }}>
                                                {formatCurrency(getFiltersTotal(r))}
                                              </div>
                                              <small className="text-muted" style={{ fontSize: '0.7rem' }}>
                                                {directFilters.reduce((sum, f) => sum + Number(f.order_count || 0), 0)} pedidos
                                              </small>
                                            </div>
                                          </div>
                                        )}
                                      </>
                                    )}
                                    <div className="col-md-3 col-sm-6">
                                      <div className="bg-white p-3 rounded border" style={{ borderLeft: '4px solid #f59e0b' }}>
                                        <small className="text-muted text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 600 }}>Total de Adicionais</small>
                                        <div className="fw-bold text-dark mt-1" style={{ fontSize: '1.1rem' }}>
                                          {formatCurrency(
                                            (['produtos_destaque', 'clientes_positivados'].includes(r.goal_subtype) && getAchievedValue(r) < getGoalTargetValue(r)
                                              ? 0
                                              : Number(r.processed_data.totals?.bonus_amount || 0)) +
                                            Number(r.processed_data.totals?.filter_commission_goal_total || 0) +
                                            Number(r.processed_data.totals?.variables_commission_goal_total || 0)
                                          )}
                                        </div>
                                      </div>
                                    </div>

                                  </div>

                                  {/* Totais por Filtro (Apenas filtros vinculados diretamente à meta) */}
                                  {directFilters.length > 0 && (
                                    <div className="mt-3">
                                      <h6 className="mb-2 text-dark fw-semibold" style={{ fontSize: '0.9rem' }}>Por Filtro</h6>
                                      <div className="table-responsive">
                                        <table className="table table-sm table-bordered bg-white">
                                          <thead className="table-light">
                                            <tr>
                                              <th>Filtro</th>
                                              <th className="text-center">%</th>
                                              <th className="text-end">{r.goal_subtype === 'clientes_positivados' ? 'Clientes' : 'Pedidos'}</th>
                                              {r.goal_subtype !== 'clientes_positivados' && (
                                                <th className="text-end">Qtd. Produtos</th>
                                              )}
                                              {r.goal_subtype !== 'clientes_positivados' && (
                                                <th className="text-end">Devolucoes</th>
                                              )}
                                              <th className="text-end">Adicional</th>
                                              <th className="text-center">Na Meta</th>
                                              {r.goal_subtype !== 'clientes_positivados' && (
                                                <>
                                                  <th className="text-end">Bruto(Filtros)</th>
                                                  <th className="text-end">Liquido(Filtros)</th>
                                                </>
                                              )}
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {directFilters.map((f, idx) => (
                                              <tr key={idx}>
                                                <td>
                                                  <div className="d-flex align-items-center flex-wrap gap-1">
                                                    <span>{f.filter_name || `Filtro #${f.filter_id}`}</span>
                                                    {isFilterCustomForGoal(f, r) && (
                                                      <span
                                                        className="badge"
                                                        style={{ background: '#ecfdf5', color: '#047857', fontSize: '0.62rem', border: '1px solid #a7f3d0' }}
                                                        title="Este filtro possui valores de referência configurados exclusivamente para esta meta"
                                                      >
                                                        ⚡ Exclusivo da Meta
                                                      </span>
                                                    )}
                                                    {f.has_accrual_rule ? (
                                                      <span className="badge ms-1" style={{ background: '#fef3c7', color: '#92400e', fontSize: '0.62rem', border: '1px solid #fde68a' }} title="Este filtro possui regra de acréscimo vinculada">
                                                        ⚡ Acréscimo
                                                      </span>
                                                    ) : null}
                                                  </div>
                                                </td>
                                                <td className="text-center small">
                                                  {(() => {
                                                    const showPct = f.show_commission_percentage === undefined || f.show_commission_percentage;
                                                    const pct = Number(f.commission_percent || 0);
                                                    const fpu = Number(f.commission_fixed_per_unit || 0);
                                                    const parts = [];
                                                    if (showPct && pct > 0) parts.push(`${formatNumber(pct)}%`);
                                                    if (fpu > 0) parts.push(`R$ ${formatNumber(fpu)}/un`);
                                                    return parts.length > 0 ? (
                                                      <span className="badge bg-light text-dark">{parts.join(' + ')}</span>
                                                    ) : '-';
                                                  })()}
                                                </td>
                                                <td className="text-end">{formatNumber(f.order_count)}</td>
                                                {r.goal_subtype !== 'clientes_positivados' && (
                                                  <td className="text-end">{formatNumber(f.total_quantity ?? 0)}</td>
                                                )}
                                                {r.goal_subtype !== 'clientes_positivados' && (
                                                  <td className="text-end">{formatCurrency(f.total_returns ?? f.total_discount)}</td>
                                                )}
                                                <td className="text-end fw-medium">{formatCurrency(f.commission_amount ?? 0)}</td>
                                                <td className="text-center">
                                                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1px', fontSize: '0.65rem' }}>
                                                    <span style={{ color: (f.include_in_goal_total ?? 1) ? '#28a745' : '#dc3545', fontWeight: 600 }}>
                                                      V: {(f.include_in_goal_total ?? 1) ? 'Sim' : 'Não'}
                                                    </span>
                                                    <span style={{ color: (f.include_commission_in_goal_total ?? 1) ? '#28a745' : '#dc3545', fontWeight: 600 }}>
                                                      A: {(f.include_commission_in_goal_total ?? 1) ? 'Sim' : 'Não'}
                                                    </span>
                                                  </div>
                                                </td>
                                                {r.goal_subtype !== 'clientes_positivados' && (
                                                  <td className="text-end">{formatCurrency(f.total_gross)}</td>
                                                )}
                                                {r.goal_subtype !== 'clientes_positivados' && (
                                                  <td className="text-end fw-medium">{formatCurrency(f.total_net)}</td>
                                                )}
                                              </tr>
                                            ))}
                                          </tbody>
                                          <tfoot className="table-light">
                                            {(() => {
                                              const totals = directFilters.reduce((acc, f) => {
                                                acc.orderCount += Number(f.order_count || 0);
                                                acc.totalQuantity += Number(f.total_quantity || 0);
                                                acc.totalReturns += Number(f.total_returns || f.total_discount || 0);
                                                acc.totalGross += Number(f.total_gross || 0);
                                                acc.totalNet += Number(f.total_net || 0);
                                                if ((f.include_commission_in_goal_total ?? 1) !== 0) {
                                                  acc.totalCommission += Number(f.commission_amount || 0);
                                                }
                                                return acc;
                                              }, { orderCount: 0, totalQuantity: 0, totalReturns: 0, totalGross: 0, totalNet: 0, totalCommission: 0 });
                                              
                                              return (
                                                <tr className="fw-bold">
                                                  <td>Total dos Filtros</td>
                                                  <td></td>
                                                  <td className="text-end">{formatNumber(totals.orderCount)}</td>
                                                  {r.goal_subtype !== 'clientes_positivados' && (
                                                    <td className="text-end">{formatNumber(totals.totalQuantity)}</td>
                                                  )}
                                                  {r.goal_subtype !== 'clientes_positivados' && (
                                                    <td className="text-end">{formatCurrency(totals.totalReturns)}</td>
                                                  )}
                                                  <td className="text-end fw-medium">{formatCurrency(totals.totalCommission)}</td>
                                                  <td></td>
                                                  {r.goal_subtype !== 'clientes_positivados' && (
                                                    <td className="text-end">{formatCurrency(totals.totalGross)}</td>
                                                  )}
                                                  {r.goal_subtype !== 'clientes_positivados' && (
                                                    <td className="text-end fw-medium">{formatCurrency(totals.totalNet)}</td>
                                                  )}
                                                </tr>
                                              );
                                            })()}
                                          </tfoot>
                                        </table>
                                      </div>
                                    </div>
                                  )}
                                  
                                  {/* Cálculos das Variáveis */}
                                  {r.processed_data.calculations?.length > 0 && (
                                    <div className="mt-3">
                                      <h6 className="mb-2 text-dark fw-semibold" style={{ fontSize: '0.9rem' }}>Variáveis de Cálculo</h6>
                                      <div className="table-responsive">
                                        <table className="table table-sm table-bordered bg-white">
                                          <thead className="table-light">
                                            <tr>
                                              <th style={{ width: '32px' }}></th>
                                              <th>Variável</th>
                                              <th className="text-center">%</th>
                                              <th className="text-end">Bruto(Filtros)</th>
                                              <th className="text-end">Devoluções</th>
                                              <th className="text-end">Líquido(Filtros)</th>
                                              <th className="text-end">Resultado</th>
                                              <th className="text-end">Adicional</th>
                                              <th className="text-center">Na Meta</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {(() => {
                                              // Coletar IDs de variáveis usadas como referência em regras de acréscimo
                                              const accrualReferencedVarIds = new Set();
                                              (r.processed_data.calculations || []).forEach(calc => {
                                                const det = (() => { try { return JSON.parse(calc.calculation_details || '{}'); } catch { return {}; } })();
                                                (det.accrual_rules || []).forEach(rule => {
                                                  if (rule.reference_type === 'variable' && rule.reference_id) {
                                                    accrualReferencedVarIds.add(Number(rule.reference_id));
                                                  }
                                                });
                                              });
                                              // Filtrar para não exibir variáveis referenciadas em regras de acréscimo
                                              return (r.processed_data.calculations || [])
                                                .filter(c => !accrualReferencedVarIds.has(Number(c.variable_id)))
                                                .map((c, idx) => {
                                              const isCalcExpanded = expandedCalcVarId === c.variable_id;
                                              const details = (() => { try { return JSON.parse(c.calculation_details || '{}'); } catch { return {}; } })();
                                              const placeholders = details.placeholders || [];
                                              const varPlaceholders = placeholders.filter(ph => ph.type === 'variable');
                                              const filterPlaceholders = placeholders.filter(ph => ph.type !== 'variable');
                                              const varGross = filterPlaceholders.reduce((s, ph) => s + Number(ph.gross || 0), 0);
                                              const varNet = filterPlaceholders.reduce((s, ph) => s + Number(ph.net || 0), 0);
                                              const varReturns = filterPlaceholders.reduce((s, ph) => s + Number(ph.returns || 0), 0);
                                              const filterNames = {};
                                              (r.processed_data.by_filter || []).forEach(f => { filterNames[f.filter_id] = f.filter_name; });
                                              let formulaWithValues = c.formula || '';
                                              placeholders.forEach(ph => {
                                                formulaWithValues = formulaWithValues.replace(
                                                  new RegExp(`\\{${ph.placeholder}\\}`, 'g'),
                                                  formatCurrency(Number(ph.value || 0))
                                                );
                                              });
                                              return (
                                                <React.Fragment key={idx}>
                                                  <tr>
                                                    <td className="text-center">
                                                      <button
                                                        type="button"
                                                        onClick={() => setExpandedCalcVarId(isCalcExpanded ? null : c.variable_id)}
                                                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px' }}
                                                      >
                                                        {isCalcExpanded ? <FiChevronUp size={14} /> : <FiChevronDown size={14} />}
                                                      </button>
                                                    </td>
                                                    <td>
                                                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                        <span>{c.variable_name || `Variável #${c.variable_id}`}</span>
                                                        <button
                                                          type="button"
                                                          onClick={async (e) => {
                                                            e.stopPropagation();
                                                            showProcessing('Exportando variável...');
                                                            try {
                                                              const res = await faturamentoService.exportVariableExcel(r.id, c.variable_id);
                                                              const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                                              const url = window.URL.createObjectURL(blob);
                                                              const link = document.createElement('a');
                                                              link.href = url;
                                                              link.setAttribute('download', `variavel_${c.variable_name || c.variable_id}_relatorio_${r.id}.xlsx`);
                                                              document.body.appendChild(link);
                                                              link.click();
                                                              link.remove();
                                                              window.URL.revokeObjectURL(url);
                                                            } catch (err) {
                                                              setMessage({ type: 'danger', text: 'Erro ao exportar variável' });
                                                            } finally {
                                                              hideProcessing();
                                                            }
                                                          }}
                                                          title="Exportar variável para Excel"
                                                          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px', color: '#6c757d', display: 'inline-flex', alignItems: 'center' }}
                                                        >
                                                          <FiDownload size={12} />
                                                        </button>
                                                      </div>
                                                    </td>
                                                    <td className="text-center small">
                                                      {(c.show_commission_percentage === undefined || c.show_commission_percentage) ? (
                                                        <span className="badge bg-light text-dark">{formatNumber(c.commission_percent)}%</span>
                                                      ) : '-'}
                                                      {(() => {
                                                        const det = (() => { try { return JSON.parse(c.calculation_details || '{}'); } catch { return {}; } })();
                                                        if (det.has_accrual_rule) {
                                                          const rules = det.accrual_rules || [];
                                                          const totalPct = rules.reduce((s, r) => s + (r.activated ? Number(r.accrual_percent || 0) : 0), 0);
                                                          const totalAmount = rules.reduce((s, r) => s + (r.activated ? Number(r.accrual_amount || 0) : 0), 0);
                                                          const anyActivated = rules.some(r => r.activated);
                                                          const parts = [];
                                                          if (totalPct > 0) parts.push(`+${formatNumber(totalPct)}%`);
                                                          if (totalAmount > 0) parts.push(`+${formatCurrency(totalAmount)}`);
                                                          const badgeText = parts.length > 0 ? parts.join(' ') : 'Acr.';
                                                          return (
                                                            <span className="badge" style={{ marginLeft: '4px', background: anyActivated ? '#d4edda' : '#fff3cd', color: anyActivated ? '#155724' : '#856404', fontSize: '0.6rem', fontWeight: 600 }}>
                                                              {anyActivated ? badgeText : 'Acr.'}
                                                            </span>
                                                          );
                                                        }
                                                        return null;
                                                      })()}
                                                      {(() => {
                                                        const det = (() => { try { return JSON.parse(c.calculation_details || '{}'); } catch { return {}; } })();
                                                        if (det.use_sold_qty_for_bonus) {
                                                          const activated = det.qty_bonus_activated;
                                                          return (
                                                            <span className="badge" style={{ marginLeft: '4px', background: activated ? '#d4edda' : '#fff3cd', color: activated ? '#155724' : '#856404', fontSize: '0.6rem', fontWeight: 600 }}>
                                                              {activated ? `+${formatCurrency(det.variable_bonus_amount)}` : 'Bonif.'}
                                                            </span>
                                                          );
                                                        }
                                                        return null;
                                                      })()}
                                                    </td>
                                                    <td className="text-end">{varGross > 0 ? formatCurrency(varGross) : '-'}</td>
                                                    <td className="text-end">{varReturns > 0 ? formatCurrency(varReturns) : '-'}</td>
                                                    <td className="text-end">{varNet > 0 ? formatCurrency(varNet) : '-'}</td>
                                                    <td className="text-end fw-medium">
                                                      {c.result === null || c.result === undefined ? '-' : formatCurrency(Number(c.result))}
                                                    </td>
                                                    <td className="text-end">{formatCurrency(c.commission_amount ?? 0)}</td>
                                                    <td className="text-center">
                                                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1px', fontSize: '0.65rem' }}>
                                                        <span style={{ color: (c.include_in_goal_total ?? 1) ? '#28a745' : '#dc3545', fontWeight: 600 }}>
                                                          V: {(c.include_in_goal_total ?? 1) ? 'Sim' : 'Não'}
                                                        </span>
                                                        <span style={{ color: (c.include_commission_in_goal_total ?? 1) ? '#28a745' : '#dc3545', fontWeight: 600 }}>
                                                          A: {(c.include_commission_in_goal_total ?? 1) ? 'Sim' : 'Não'}
                                                        </span>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                  {isCalcExpanded && (
                                                    <tr>
                                                      <td colSpan="9" className="p-0">
                                                        <div style={{ padding: '6px 10px 6px 24px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0', fontSize: '0.72rem' }}>
                                                          <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px', flexWrap: 'wrap' }}>
                                                            <span className="text-muted" style={{ fontWeight: 600 }}>Fórmula:</span>
                                                            <code style={{ background: '#f1f5f9', padding: '1px 6px', borderRadius: '3px', fontSize: '0.7rem', color: '#334155' }}>
                                                              {c.formula}
                                                            </code>
                                                          </div>
                                                          <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
                                                            <span className="text-muted" style={{ fontWeight: 600 }}>Cálculo:</span>
                                                            <code style={{ background: '#f1f5f9', padding: '1px 6px', borderRadius: '3px', fontSize: '0.7rem', color: '#334155' }}>
                                                              {formulaWithValues}
                                                            </code>
                                                              {c.result !== null && c.result !== undefined && (
                                                              <span className="fw-bold" style={{ fontSize: '0.72rem', color: '#0d6efd' }}>
                                                                = {formatCurrency(Number(c.result))}
                                                              </span>
                                                            )}
                                                          </div>
                                                          {/* Acréscimo info */}
                                                          {(() => {
                                                            const det = (() => { try { return JSON.parse(c.calculation_details || '{}'); } catch { return {}; } })();
                                                            const rules = det.accrual_rules || [];
                                                            if (det.has_accrual_rule && rules.length > 0) {
                                                              const anyActivated = rules.some(r => r.activated);
                                                              return (
                                                                <div style={{ marginTop: '6px' }}>
                                                                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '4px' }}>
                                                                    <span className="text-muted" style={{ fontWeight: 600, fontSize: '0.7rem' }}>Regras de Acréscimo:</span>
                                                                    <span style={{
                                                                      display: 'inline-flex', alignItems: 'center', gap: '4px',
                                                                      fontSize: '0.68rem', padding: '2px 8px', borderRadius: '4px',
                                                                      background: anyActivated ? '#d4edda' : '#fff3cd',
                                                                      color: anyActivated ? '#155724' : '#856404',
                                                                      fontWeight: 600
                                                                    }}>
                                                                      {anyActivated ? '✓ Com acréscimo' : '✗ Nenhum ativado'}
                                                                    </span>
                                                                  </div>
                                                                  {rules.map((rule, rIdx) => {
                                                                    const hasQtyThreshold = Boolean(rule.threshold_quantity && Number(rule.threshold_quantity) > 0);
                                                                    const thresholdVal = Number(rule.threshold || rule.threshold_value || 0);
                                                                    const currentVal = rule.reference_value != null ? Number(rule.reference_value) : null;
                                                                    const thresholdQty = hasQtyThreshold ? Number(rule.threshold_quantity) : 0;
                                                                    const currentQty = rule.reference_quantity != null ? Number(rule.reference_quantity) : 0;

                                                                    const valMet = thresholdVal > 0 ? (currentVal !== null && currentVal >= thresholdVal) : true;
                                                                    const qtyMet = hasQtyThreshold ? (currentQty >= thresholdQty) : true;
                                                                    const isRuleActive = Boolean(rule.activated || (valMet && qtyMet));

                                                                    const bParts = [];
                                                                    if (rule.accrual_percent && Number(rule.accrual_percent) > 0) bParts.push(`+${formatNumber(rule.accrual_percent)}%`);
                                                                    if (rule.accrual_amount && Number(rule.accrual_amount) > 0) bParts.push(`+${formatCurrency(rule.accrual_amount)}`);
                                                                    const bonusTxt = bParts.join(' e ') || '+0%';

                                                                    return (
                                                                      <div key={rIdx} style={{
                                                                        display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap',
                                                                        fontSize: '0.65rem', padding: '3px 8px', marginTop: '2px',
                                                                        borderRadius: '4px',
                                                                        background: isRuleActive ? '#d4edda' : '#f8f9fa',
                                                                        color: isRuleActive ? '#155724' : '#6c757d'
                                                                      }}>
                                                                        <span style={{ fontWeight: 600 }}>{rule.reference_name || (rule.reference_type === 'filter' ? `Filtro #${rule.reference_id}` : rule.reference_type === 'report' ? `Relatório #${rule.reference_id}` : `Variável #${rule.reference_id}`)}</span>
                                                                        {thresholdVal > 0 && (
                                                                          <>
                                                                            <span>{valMet ? '≥' : '<'} {formatCurrency(thresholdVal)}</span>
                                                                            <span>(valor: {currentVal != null ? formatCurrency(currentVal) : 'N/D'})</span>
                                                                          </>
                                                                        )}
                                                                        {hasQtyThreshold && (
                                                                          <>
                                                                            <span>{qtyMet ? '≥' : '<'} {thresholdQty} un</span>
                                                                            <span>(qtd: {rule.reference_quantity != null ? currentQty : 'N/D'})</span>
                                                                          </>
                                                                        )}
                                                                        {thresholdVal <= 0 && !hasQtyThreshold && (
                                                                          <span>(valor: {currentVal != null ? formatCurrency(currentVal) : 'N/D'})</span>
                                                                        )}
                                                                        {thresholdVal <= 0 && hasQtyThreshold && currentVal != null && (
                                                                          <span>(venda: {formatCurrency(currentVal)})</span>
                                                                        )}
                                                                        <span style={{ fontWeight: 600 }}>→ {bonusTxt}</span>
                                                                        {isRuleActive && <span>✓</span>}
                                                                      </div>
                                                                    );
                                                                  })}
                                                                </div>
                                                              );
                                                            }
                                                            return null;
                                                          })()}
                                                          {/* Bonificação por Quantidade */}
                                                          {(() => {
                                                            const det = (() => { try { return JSON.parse(c.calculation_details || '{}'); } catch { return {}; } })();
                                                            if (det.use_sold_qty_for_bonus) {
                                                              const activated = det.qty_bonus_activated;
                                                              return (
                                                                <div style={{ marginTop: '6px' }}>
                                                                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '4px' }}>
                                                                    <span className="text-muted" style={{ fontWeight: 600, fontSize: '0.7rem' }}>Bonificação por Quantidade:</span>
                                                                    <span style={{
                                                                      display: 'inline-flex', alignItems: 'center', gap: '4px',
                                                                      fontSize: '0.68rem', padding: '2px 8px', borderRadius: '4px',
                                                                      background: activated ? '#d4edda' : '#fff3cd',
                                                                      color: activated ? '#155724' : '#856404',
                                                                      fontWeight: 600
                                                                    }}>
                                                                      {activated ? '✓ Bonificação aplicada' : '✗ Não atingiu'}
                                                                    </span>
                                                                  </div>
                                                                  <div style={{
                                                                    display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap',
                                                                    fontSize: '0.65rem', padding: '3px 8px', marginTop: '2px',
                                                                    borderRadius: '4px',
                                                                    background: activated ? '#d4edda' : '#f8f9fa',
                                                                    color: activated ? '#155724' : '#6c757d'
                                                                  }}>
                                                                    <span>Qtd. vendida: <strong>{det.total_sold_qty ?? 0}</strong></span>
                                                                    <span>{activated ? '≥' : '<'} <strong>{det.bonus_validation_qty}</strong> un</span>
                                                                    <span>→ +<strong>{formatCurrency(det.variable_bonus_amount)}</strong></span>
                                                                    {activated && <span>✓</span>}
                                                                  </div>
                                                                </div>
                                                              );
                                                            }
                                                            return null;
                                                          })()}
                                                          {/* Variable dependencies (nested variables) */}
                                                          {varPlaceholders.length > 0 && (
                                                            <div style={{ marginTop: '6px' }}>
                                                              <span className="text-muted" style={{ fontWeight: 600, fontSize: '0.7rem' }}>Variáveis dependentes:</span>
                                                              {varPlaceholders.map((ph, phIdx) => (
                                                                <div
                                                                  key={phIdx}
                                                                  style={{
                                                                    marginTop: '4px',
                                                                    padding: '6px 8px',
                                                                    background: '#f1f5f9',
                                                                    borderRadius: '4px',
                                                                    borderLeft: '3px solid #6f42c1',
                                                                    fontSize: '0.68rem'
                                                                  }}
                                                                >
                                                                  <div style={{ fontWeight: 600, color: '#475569', marginBottom: '2px' }}>
                                                                    {ph.dep_var_name || `Variável #${ph.depends_on_variable_id}`}
                                                                  </div>
                                                                  <div style={{ color: '#64748b', marginBottom: '2px' }}>
                                                                    Fórmula: <code style={{ background: '#e2e8f0', padding: '0 4px', borderRadius: '2px', fontSize: '0.65rem' }}>{ph.dep_formula}</code>
                                                                  </div>
                                                                  <div style={{ color: '#0d6efd' }}>
                                                                    Resultado: {formatCurrency(Number(ph.dep_result || 0))}
                                                                    <span className="text-muted" style={{ marginLeft: '8px' }}>
                                                                      Adicional: {formatCurrency(Number(ph.dep_commission_amount || 0))}
                                                                    </span>
                                                                  </div>
                                                                  {ph.dep_placeholders && ph.dep_placeholders.filter(dph => dph.type !== 'variable').length > 0 && (
                                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2px', marginTop: '3px' }}>
                                                                      {ph.dep_placeholders.filter(dph => dph.type !== 'variable').map((dph, dphIdx) => (
                                                                        <span
                                                                          key={dphIdx}
                                                                          style={{
                                                                            fontSize: '0.62rem',
                                                                            background: isPlaceholderActive(dph, r) ? '#f0fdf4' : '#ffffff',
                                                                            border: isPlaceholderActive(dph, r) ? '1px solid #86efac' : '1px solid #e2e8f0',
                                                                            borderRadius: '3px',
                                                                            padding: '1px 5px',
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            gap: '2px',
                                                                            whiteSpace: 'nowrap'
                                                                          }}
                                                                        >
                                                                          <span style={{ fontWeight: 600, color: '#475569' }}>{dph.placeholder}:</span>
                                                                          <span style={{ color: '#64748b' }}>{filterNames[dph.filter_id] || `Filtro #${dph.filter_id}`}</span>
                                                                          <span style={{ color: '#6f42c1' }}>Q: {formatNumber(dph.filter_sold_qty ?? 0)}</span>
                                                                          <span style={{ color: '#28a745' }}>B: {formatCurrency(dph.gross || 0)}</span>
                                                                          <span style={{ color: '#dc3545' }}>D: {formatCurrency(dph.returns || 0)}</span>
                                                                          <span style={{ color: '#17a2b8' }}>L: {formatCurrency(dph.net || 0)}</span>
                                                                          {(() => {
                                                                              const isCustom = isFilterCustomForGoal(dph, r);
                                                                              if (!isCustom) return null;
                                                                              const usesBase = dph.use_goal_filter_config === false || dph.use_goal_filter_config === 0;
                                                                              if (usesBase) {
                                                                                return (
                                                                                  <span className="badge ms-1" style={{ background: '#f1f5f9', color: '#64748b', fontSize: '0.55rem', border: '1px solid #e2e8f0', padding: '1px 4px' }} title="Calculado usando regras base do filtro">Filtro Base</span>
                                                                                );
                                                                              }
                                                                              return (
                                                                                <span className="badge ms-1" style={{ background: '#ecfdf5', color: '#047857', fontSize: '0.55rem', border: '1px solid #a7f3d0', padding: '1px 4px' }} title="Valores configurados exclusivamente para esta meta">⚡ Exclusivo da Meta</span>
                                                                              );
                                                                            })()}
                                                                        </span>
                                                                      ))}
                                                                    </div>
                                                                  )}
                                                                </div>
                                                              ))}
                                                            </div>
                                                          )}
                                                          {/* Filter placeholders */}
                                                          {filterPlaceholders.length > 0 && (
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '3px', marginTop: '4px', maxHeight: '80px', overflowY: 'auto' }}>
                                                              {filterPlaceholders.map((ph, phIdx) => (
                                                                 <span
                                                                   key={phIdx}
                                                                   style={{
                                                                     fontSize: '0.65rem',
                                                                     background: isPlaceholderActive(ph, r) ? '#f0fdf4' : '#ffffff',
                                                                     border: isPlaceholderActive(ph, r) ? '1px solid #86efac' : '1px solid #e2e8f0',
                                                                     borderRadius: '4px',
                                                                     padding: '2px 7px',
                                                                     display: 'inline-flex',
                                                                     alignItems: 'center',
                                                                     gap: '3px',
                                                                     whiteSpace: 'nowrap'
                                                                   }}
                                                                 >
                                                                   <span style={{ fontWeight: 600, color: '#475569' }}>{ph.placeholder}:</span>
                                                                   <span style={{ color: '#64748b' }}>{filterNames[ph.filter_id] || `Filtro #${ph.filter_id}`}</span>
                                                                   <span style={{ color: '#6f42c1' }}>Q: {formatNumber(ph.filter_sold_qty ?? 0)}</span>
                                                                  <span style={{ color: '#28a745' }}>B: {formatCurrency(ph.gross || 0)}</span>
                                                                  <span style={{ color: '#dc3545' }}>D: {formatCurrency(ph.returns || 0)}</span>
                                                                  <span style={{ color: '#17a2b8' }}>L: {formatCurrency(ph.net || 0)}</span>
                                                                  {(() => {
                                                                      const isCustom = isFilterCustomForGoal(ph, r);
                                                                      if (!isCustom) return null;
                                                                      const usesBase = ph.use_goal_filter_config === false || ph.use_goal_filter_config === 0;
                                                                      if (usesBase) {
                                                                        return (
                                                                          <span className="badge ms-1" style={{ background: '#f1f5f9', color: '#64748b', fontSize: '0.55rem', border: '1px solid #e2e8f0', padding: '1px 4px' }} title="Calculado usando regras base do filtro">Filtro Base</span>
                                                                        );
                                                                      }
                                                                      return (
                                                                        <span className="badge ms-1" style={{ background: '#ecfdf5', color: '#047857', fontSize: '0.55rem', border: '1px solid #a7f3d0', padding: '1px 4px' }} title="Valores configurados exclusivamente para esta meta">⚡ Exclusivo da Meta</span>
                                                                      );
                                                                    })()}
                                                                  {(() => {
                                                                    const pct = Number(ph.filter_commission_percent);
                                                                    const fpu = Number(ph.filter_commission_fixed_per_unit);
                                                                    const parts = [];
                                                                    if (pct > 0) parts.push(<span key="pct" style={{ color: '#f59e0b' }}>C: {formatNumber(pct)}%</span>);
                                                                    if (fpu > 0) parts.push(<span key="fpu" style={{ color: '#d97706' }}>Fixo: R$ {formatNumber(fpu)}/un</span>);
                                                                    return parts;
                                                                  })()}
                                                                </span>
                                                              ))}
                                                            </div>
                                                          )}
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  )}
                                                </React.Fragment>
                                              );
                                            });
                                          })()}
                                          </tbody>
                                          <tfoot className="table-light">
                                            {(() => {
                                              const calcTotals = r.processed_data.calculations.reduce((acc, c) => {
                                                if ((c.include_commission_in_goal_total ?? 1) !== 0) {
                                                  acc.totalCommission += Number(c.commission_amount || 0);
                                                }
                                                acc.totalResult += Number(c.result || 0);
                                                const det = (() => { try { return JSON.parse(c.calculation_details || '{}'); } catch { return {}; } })();
                                                const phs = det.placeholders || [];
                                                acc.totalGross += phs.reduce((s, ph) => s + Number(ph.gross || 0), 0);
                                                acc.totalNet += phs.reduce((s, ph) => s + Number(ph.net || 0), 0);
                                                acc.totalReturns += phs.reduce((s, ph) => s + Number(ph.returns || 0), 0);
                                                return acc;
                                              }, { totalCommission: 0, totalResult: 0, totalGross: 0, totalNet: 0, totalReturns: 0 });

                                              return (
                                                <tr className="fw-bold">
                                                  <td></td>
                                                  <td>Total</td>
                                                  <td></td>
                                                  <td className="text-end">{calcTotals.totalGross > 0 ? formatCurrency(calcTotals.totalGross) : '-'}</td>
                                                  <td className="text-end">{calcTotals.totalReturns > 0 ? formatCurrency(calcTotals.totalReturns) : '-'}</td>
                                                  <td className="text-end">{calcTotals.totalNet > 0 ? formatCurrency(calcTotals.totalNet) : '-'}</td>
                                                  <td className="text-end">{formatCurrency(calcTotals.totalResult)}</td>
                                                  <td className="text-end">{formatCurrency(calcTotals.totalCommission)}</td>
                                                  <td></td>
                                                </tr>
                                              );
                                            })()}
                                          </tfoot>
                                        </table>
                                      </div>
                                    </div>
                                  )}
                                </>
                              );
                            })()
                          ) : r.status === 'completed' ? (
                                <div className="text-muted small">
                                  <p className="mb-1">Relatório processado, mas sem dados encontrados no periodo.</p>
                                  {r.processed_data?.totals?.generated_at && (
                                    <p className="mb-0">
                                      Processado em: <strong>{new Date(r.processed_data.totals.generated_at).toLocaleString('pt-BR')}</strong>
                                    </p>
                                  )}
                                </div>
                              ) : (
                                <div className="text-muted small">
                                  <p className="mb-1">Nenhum valor processado disponivel.</p>
                                  <p className="mb-0">Status atual: <strong>{r.status}</strong></p>
                                  {r.status === 'draft' && <p className="mb-0 mt-1">O sincronizador processara este relatorio em breve.</p>}
                                  {r.status === 'processing' && <p className="mb-0 mt-1">O sincronizador esta processando este relatorio.</p>}
                                  {r.status === 'failed' && <p className="mb-0 mt-1 text-danger">O processamento falhou. Verifique os logs.</p>}
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  )))}
                </tbody>
              </table>
            </div>

            {/* Paginação */}
            <BIPagination
              page={page}
              perPage={perPage}
              total={totalRecords}
              onPageChange={handlePageChange}
              onPerPageChange={handlePerPageChange}
              itemLabel="relatórios"
              perPageOptions={[10, 25, 50, 100, 200]}
            />
          </div>
        </div>
      </div>

      {/* Modal Novo/Editar Relatorio */}
      {showModal && (
        <div
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, backdropFilter: 'blur(4px)', padding: '20px',
            overflowY: 'auto'
          }}
        >
          <div
            style={{
              background: 'white', borderRadius: '20px', width: '100%',
              maxWidth: '780px', maxHeight: '90vh',
              boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
              animation: 'modalSlideIn 0.25s ease',
              display: 'flex', flexDirection: 'column'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div style={{
              padding: '24px 28px 20px',
              borderBottom: '1px solid var(--border)',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              flexShrink: 0
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{
                  width: '44px', height: '44px', borderRadius: '12px',
                  background: 'var(--primary)', color: 'white',
                  display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                  <FiFileText size={20} />
                </div>
                <div>
                  <h5 style={{ margin: 0, fontWeight: 700, fontSize: '1rem' }}>
                    {form.id ? 'Editar relatorio' : 'Novo relatorio'}
                  </h5>
                  <p style={{ margin: 0, fontSize: '0.78rem', color: 'var(--text-muted)' }}>
                    {form.id ? 'Atualize os dados do relatorio' : 'Vincule uma ou mais metas e o periodo de processamento'}
                  </p>
                </div>
              </div>
              <button
                type="button"
                onClick={handleCloseModal}
                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', borderRadius: '8px' }}
              >
                <FiX size={20} color="var(--text-muted)" />
              </button>
            </div>

            {/* Modal Body */}
            <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
              <div style={{ padding: '24px 28px', overflowY: 'auto', flex: 1 }}>
                
                {/* Filtrar por filial */}
                <div className="form-group-modern mb-3" style={{ width: '100%' }}>
                  <MultiSelectSearch
                    label="Filtrar por filial"
                    placeholder="Selecione filial..."
                    value={modalBranchFilter}
                    onChange={setModalBranchFilter}
                    options={branches}
                    badgeColor="#10b981"
                    getOptionLabel={(opt) => opt.label}
                    getOptionValue={(opt) => opt.id}
                    style={{ width: '100%' }}
                  />
                </div>

                {/* Filtrar período da meta */}
                <div className="form-group-modern mb-3" style={{ width: '100%' }}>
                  <label>Filtrar período da meta</label>
                  <div className="d-flex gap-2" style={{ width: '100%' }}>
                    <select className="form-control-modern" value={modalGoalMonth} onChange={(e) => setModalGoalMonth(e.target.value)} style={{ flex: 1, width: '100%' }}>
                      <option value="">Todos os meses</option>
                      {MESES.map(m => (
                        <option key={m.v} value={m.v}>{m.n}</option>
                      ))}
                    </select>
                    <select className="form-control-modern" value={modalGoalYear} onChange={(e) => setModalGoalYear(e.target.value)} style={{ flex: 1, width: '100%' }}>
                      <option value="">Todos os anos</option>
                      {Array.from(new Set(goals.map(g => g.reference_year).filter(Boolean))).sort((a, b) => b - a).map(year => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Metas vinculadas */}
                <div className="form-group-modern mb-3" style={{ width: '100%' }}>
                  <MultiSelectSearch
                    label="Metas vinculadas *"
                    placeholder="Selecione as metas..."
                    value={form.goal_ids}
                    onChange={(selected) => {
                      const wasSingleGoalBefore = form.goal_ids.length === 1;
                      const isSingleGoalNow = selected.length === 1;
                      
                      let newName = form.name;
                      
                      if (selected.length === 0) {
                        newName = '';
                      } else if (selected.length === 1) {
                        newName = form.name || generateReportNameFromGoal(selected[0]);
                      } else {
                        const firstGoalGeneratedName = wasSingleGoalBefore ? generateReportNameFromGoal(form.goal_ids[0]) : '';
                        if (form.name === firstGoalGeneratedName || !form.name) {
                          newName = '';
                        }
                      }

                      setForm({
                        ...form,
                        goal_ids: selected,
                        name: newName
                      });

                      if (!form.id && selected.length > 0) {
                        const warnings = [];
                        selected.forEach(goalId => {
                          const existingReports = allReports.filter(r => Number(r.goal_id) === Number(goalId));
                          if (existingReports.length > 0) {
                            const goal = goals.find(g => Number(g.id) === Number(goalId));
                            warnings.push({
                              goalId,
                              goalLabel: goal ? goalLabel(goal) : `Meta #${goalId}`,
                              reports: existingReports
                            });
                          }
                        });
                        if (warnings.length > 0) {
                          setExistingReportWarnings(warnings);
                          setShowExistingReportWarning(true);
                        }
                      }
                    }}
                    options={filteredModalGoals}
                    badgeColor="#6f42c1"
                    getOptionLabel={(opt) => goalLabel(opt)}
                    getOptionValue={(opt) => opt.id}
                    getOptionClassName={(opt) => isGoalWithReport(opt) ? 'has-report' : ''}
                    getOptionStyle={(opt) => isGoalWithReport(opt) ? {
                      backgroundColor: '#f0fdf4',
                      borderLeft: '4px solid #16a34a'
                    } : {}}
                    renderOptionBadge={(opt) => isGoalWithReport(opt) ? (
                      <span
                        style={{
                          backgroundColor: '#dcfce7',
                          color: '#15803d',
                          border: '1px solid #86efac',
                          fontSize: '0.68rem',
                          fontWeight: 700,
                          padding: '2px 7px',
                          borderRadius: '6px',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '3px',
                          whiteSpace: 'nowrap',
                          marginRight: '6px'
                        }}
                        title="Esta meta já possui relatório cadastrado"
                      >
                        ✓ Com relatório
                      </span>
                    ) : null}
                    style={{ width: '100%' }}
                  />
                  {(modalBranchFilter.length > 0 || modalGoalYear || modalGoalMonth) && filteredModalGoals.length === 0 && (
                    <small className="text-warning d-block mt-1">Nenhuma meta encontrada para o(s) filtro(s) selecionado(s).</small>
                  )}
                  <div className="d-flex align-items-center gap-2 mt-1" style={{ fontSize: '0.74rem', color: 'var(--text-muted)' }}>
                    <span style={{ display: 'inline-block', width: '10px', height: '10px', backgroundColor: '#f0fdf4', border: '1px solid #16a34a', borderRadius: '2px' }}></span>
                    <span>Metas destacadas em verde com <strong>"✓ Com relatório"</strong> já possuem relatório cadastrado.</span>
                  </div>
                </div>

                {/* Nome do Relatório */}
                <div className="form-group-modern mb-3" style={{ width: '100%' }}>
                  <label>Nome {form.goal_ids.length > 1 ? <small className="text-muted ms-1">(opcional - cada relatório usará o nome da sua meta)</small> : ''}</label>
                  <input 
                    className="form-control-modern" 
                    style={{ width: '100%' }}
                    value={form.name} 
                    onChange={(e) => setForm({ ...form, name: e.target.value })} 
                    placeholder={form.goal_ids.length > 1 ? "Deixe em branco para usar o nome de cada meta" : "Ex: Relatório Janeiro 2025 (gerado automaticamente)"} 
                  />
                </div>

                {/* Status */}
                <div className="form-group-modern mb-3" style={{ width: '100%' }}>
                  <label>Status</label>
                  <select className="form-control-modern" style={{ width: '100%' }} value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
                    <option value="draft">Pendente</option>
                    <option value="processing">Processando</option>
                    <option value="completed">Processado</option>
                    <option value="failed">Falhou</option>
                  </select>
                </div>

                {/* Selecionar mês */}
                <div className="form-group-modern mb-3" style={{ width: '100%' }}>
                  <label>Selecionar mês</label>
                  <input
                    type="month"
                    className="form-control-modern"
                    style={{ width: '100%' }}
                    value={selectedMonth}
                    onChange={(e) => handleMonthChange(e.target.value)}
                  />
                </div>

                {/* Data início */}
                <div className="form-group-modern mb-3" style={{ width: '100%' }}>
                  <label>Data inicio</label>
                  <input type="date" className="form-control-modern" style={{ width: '100%' }} required value={form.period_start} onChange={(e) => setForm({ ...form, period_start: e.target.value })} />
                </div>

                {/* Data fim */}
                <div className="form-group-modern mb-3" style={{ width: '100%' }}>
                  <label>Data fim</label>
                  <input type="date" className="form-control-modern" style={{ width: '100%' }} required value={form.period_end} onChange={(e) => setForm({ ...form, period_end: e.target.value })} />
                </div>

              </div>

               {/* Modal Footer */}
               <div style={{
                 padding: '16px 28px 24px',
                 display: 'flex', justifyContent: 'flex-end', gap: '12px',
                 borderTop: '1px solid var(--border)',
                 flexShrink: 0
               }}>
                <button
                  type="button"
                  className="btn-modern btn-modern-secondary"
                  onClick={handleCloseModal}
                  disabled={saving}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="btn-modern btn-modern-primary"
                  disabled={saving}
                >
                  {saving ? 'Salvando...' : form.id ? 'Atualizar' : <><FiPlus className="me-1" />Salvar</>}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de Confirmação de Exclusão */}
      {showDeleteModal && reportToDelete && (
        <div
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, backdropFilter: 'blur(4px)', padding: '20px'
          }}
          onClick={(e) => e.target === e.currentTarget && setShowDeleteModal(false)}
        >
          <div style={{
            background: 'white', borderRadius: '20px',
            width: '100%', maxWidth: '450px',
            boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
            animation: 'modalSlideIn 0.25s ease',
            overflow: 'hidden'
          }}>
            {/* Ícone de Aviso */}
            <div style={{
              padding: '32px 28px 20px',
              textAlign: 'center'
            }}>
              <div style={{
                width: '64px', height: '64px', borderRadius: '50%',
                background: '#fee2e2', color: '#dc2626',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 16px'
              }}>
                <FiTrash2 size={32} />
              </div>
              <h4 style={{ margin: '0 0 8px', fontWeight: 700, fontSize: '1.25rem', color: '#1e293b' }}>
                Confirmar Exclusão
              </h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#64748b' }}>
                Tem certeza que deseja excluir o relatório
              </p>
              <p style={{ margin: '8px 0 0', fontWeight: 600, fontSize: '1rem', color: '#1e293b' }}>
                "{reportToDelete.name}"?
              </p>
            </div>

            {/* Alerta */}
            <div style={{
              padding: '0 28px 20px',
              textAlign: 'center'
            }}>
              <div style={{
                padding: '12px 16px',
                background: '#fef3c7',
                border: '1px solid #fbbf24',
                borderRadius: '8px',
                fontSize: '0.85rem',
                color: '#92400e'
              }}>
                ⚠️ Esta ação não pode ser desfeita. Todos os dados do relatório serão removidos.
              </div>
            </div>

            {/* Footer */}
            <div style={{
              padding: '16px 28px 24px',
              display: 'flex', justifyContent: 'center', gap: '12px'
            }}>
              <button
                type="button"
                className="btn-modern btn-modern-secondary"
                onClick={() => setShowDeleteModal(false)}
                disabled={deleting}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn-modern btn-modern-danger"
                onClick={confirmDelete}
                disabled={deleting}
              >
                <FiTrash2 className="me-2" size={16} />
                {deleting ? 'Excluindo...' : 'Sim, Excluir'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Confirmação de Reprocessamento */}
      {showReprocessModal && reportToReprocess && (
        <div
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, backdropFilter: 'blur(4px)', padding: '20px'
          }}
          onClick={(e) => e.target === e.currentTarget && setShowReprocessModal(false)}
        >
          <div style={{
            background: 'white', borderRadius: '20px',
            width: '100%', maxWidth: '500px',
            boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
            animation: 'modalSlideIn 0.25s ease',
            overflow: 'hidden'
          }}>
            {/* Ícone de Aviso */}
            <div style={{
              padding: '32px 28px 20px',
              textAlign: 'center'
            }}>
              <div style={{
                width: '64px', height: '64px', borderRadius: '50%',
                background: '#dbeafe', color: '#2563eb',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 16px'
              }}>
                <FiRefreshCw size={32} />
              </div>
              <h4 style={{ margin: '0 0 8px', fontWeight: 700, fontSize: '1.25rem', color: '#1e293b' }}>
                Confirmar Reprocessamento
              </h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#64748b' }}>
                Tem certeza que deseja reprocessar o relatório
              </p>
              <p style={{ margin: '8px 0 0', fontWeight: 600, fontSize: '1rem', color: '#1e293b' }}>
                "{reportToReprocess.name}"?
              </p>
            </div>

            {/* Alerta */}
            <div style={{
              padding: '0 28px 20px',
              textAlign: 'center'
            }}>
              <div style={{
                padding: '12px 16px',
                background: '#fef3c7',
                border: '1px solid #fbbf24',
                borderRadius: '8px',
                fontSize: '0.85rem',
                color: '#92400e'
              }}>
                ⚠️ Esta ação irá limpar todos os dados atuais e enviar o relatório para processamento novamente.
              </div>
            </div>

            {/* Footer */}
            <div style={{
              padding: '16px 28px 24px',
              display: 'flex', justifyContent: 'center', gap: '12px'
            }}>
              <button
                type="button"
                className="btn-modern btn-modern-secondary"
                onClick={() => setShowReprocessModal(false)}
                disabled={reprocessing}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn-modern btn-modern-warning"
                onClick={confirmReprocess}
                disabled={reprocessing}
              >
                <FiRefreshCw className="me-2" size={16} />
                {reprocessing ? 'Reprocessando...' : 'Sim, Reprocessar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Confirmação de Finalização */}
      {showFinalizeModal && reportToFinalize && (
        <div
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, backdropFilter: 'blur(4px)', padding: '20px'
          }}
          onClick={(e) => e.target === e.currentTarget && setShowFinalizeModal(false)}
        >
          <div style={{
            background: 'white', borderRadius: '20px',
            width: '100%', maxWidth: '500px',
            boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
            animation: 'modalSlideIn 0.25s ease',
            overflow: 'hidden'
          }}>
            <div style={{ padding: '32px 28px 20px', textAlign: 'center' }}>
              <div style={{
                width: '64px', height: '64px', borderRadius: '50%',
                background: '#d1fae5', color: '#059669',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 16px'
              }}>
                <FiLock size={32} />
              </div>
              <h4 style={{ margin: '0 0 8px', fontWeight: 700, fontSize: '1.25rem', color: '#1e293b' }}>
                Confirmar Finalização
              </h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#64748b' }}>
                Tem certeza que deseja finalizar o relatório
              </p>
              <p style={{ margin: '8px 0 0', fontWeight: 600, fontSize: '1rem', color: '#1e293b' }}>
                "{reportToFinalize.name}"?
              </p>
            </div>

            <div style={{ padding: '0 28px 20px', textAlign: 'center' }}>
              <div style={{
                padding: '12px 16px',
                background: '#fef3c7',
                border: '1px solid #fbbf24',
                borderRadius: '8px',
                fontSize: '0.85rem',
                color: '#92400e'
              }}>
                Ao finalizar, o relatório não poderá mais ser reprocessado nem excluído, a menos que você seja um administrador.
              </div>
            </div>

            <div style={{ padding: '16px 28px 24px', display: 'flex', justifyContent: 'center', gap: '12px' }}>
              <button
                type="button"
                className="btn-modern btn-modern-secondary"
                onClick={() => setShowFinalizeModal(false)}
                disabled={finalizing}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn-modern btn-modern-success"
                onClick={confirmFinalize}
                disabled={finalizing}
              >
                <FiLock className="me-2" size={16} />
                {finalizing ? 'Finalizando...' : 'Sim, Finalizar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Confirmação de Reprocessamento em Lote */}
      {showBulkReprocessModal && (
        <div
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, backdropFilter: 'blur(4px)', padding: '20px'
          }}
          onClick={(e) => e.target === e.currentTarget && setShowBulkReprocessModal(false)}
        >
          <div style={{
            background: 'white', borderRadius: '20px',
            width: '100%', maxWidth: '500px',
            boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
            animation: 'modalSlideIn 0.25s ease',
            overflow: 'hidden'
          }}>
            <div style={{ padding: '32px 28px 20px', textAlign: 'center' }}>
              <div style={{
                width: '64px', height: '64px', borderRadius: '50%',
                background: '#fef3c7', color: '#f59e0b',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 16px'
              }}>
                <FiRefreshCw size={32} />
              </div>
              <h4 style={{ margin: '0 0 8px', fontWeight: 700, fontSize: '1.25rem', color: '#1e293b' }}>
                Reiniciar Lote de Relatórios
              </h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#64748b' }}>
                Tem certeza que deseja reprocessar os <strong>{selectedReportIds.length}</strong> relatórios selecionados?
              </p>
            </div>

            <div style={{ padding: '0 28px 20px', textAlign: 'center' }}>
              <div style={{
                padding: '12px 16px',
                background: '#fef3c7',
                border: '1px solid #fbbf24',
                borderRadius: '8px',
                fontSize: '0.85rem',
                color: '#92400e'
              }}>
                ⚠️ Esta ação irá reiniciar o processamento de todos os itens selecionados. Os dados atuais serão substituídos assim que o sincronizador processá-los novamente.
              </div>
            </div>

            <div style={{ padding: '16px 28px 24px', display: 'flex', justifyContent: 'center', gap: '12px' }}>
              <button
                type="button"
                className="btn-modern btn-modern-secondary"
                onClick={() => setShowBulkReprocessModal(false)}
                disabled={bulkReprocessing}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn-modern btn-modern-warning"
                onClick={confirmBulkReprocess}
                disabled={bulkReprocessing}
              >
                <FiRefreshCw className={`me-2 ${bulkReprocessing ? 'spin-ico' : ''}`} size={16} />
                {bulkReprocessing ? 'Processando Lote...' : 'Sim, Reiniciar Todos'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Confirmação de Finalização em Lote */}
      {showBulkFinalizeModal && (
        <div
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, backdropFilter: 'blur(4px)', padding: '20px'
          }}
          onClick={(e) => e.target === e.currentTarget && setShowBulkFinalizeModal(false)}
        >
          <div style={{
            background: 'white', borderRadius: '20px',
            width: '100%', maxWidth: '500px',
            boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
            animation: 'modalSlideIn 0.25s ease',
            overflow: 'hidden'
          }}>
            <div style={{ padding: '32px 28px 20px', textAlign: 'center' }}>
              <div style={{
                width: '64px', height: '64px', borderRadius: '50%',
                background: '#d1fae5', color: '#059669',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 16px'
              }}>
                <FiLock size={32} />
              </div>
              <h4 style={{ margin: '0 0 8px', fontWeight: 700, fontSize: '1.25rem', color: '#1e293b' }}>
                Finalizar Lote de Relatórios
              </h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#64748b' }}>
                Tem certeza que deseja finalizar os <strong>{selectedReportIds.length}</strong> relatórios selecionados?
              </p>
            </div>

            <div style={{ padding: '0 28px 20px', textAlign: 'center' }}>
              <div style={{
                padding: '12px 16px',
                background: '#fef3c7',
                border: '1px solid #fbbf24',
                borderRadius: '8px',
                fontSize: '0.85rem',
                color: '#92400e'
              }}>
                Ao finalizar, estes relatórios não poderão mais ser reprocessados nem excluídos, a menos que você seja um administrador.
              </div>
            </div>

            <div style={{ padding: '16px 28px 24px', display: 'flex', justifyContent: 'center', gap: '12px' }}>
              <button
                type="button"
                className="btn-modern btn-modern-secondary"
                onClick={() => setShowBulkFinalizeModal(false)}
                disabled={bulkFinalizing}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn-modern btn-modern-success"
                onClick={confirmBulkFinalize}
                disabled={bulkFinalizing}
              >
                <FiLock className={`me-2 ${bulkFinalizing ? 'spin-ico' : ''}`} size={16} />
                {bulkFinalizing ? 'Finalizando Lote...' : 'Sim, Finalizar Todos'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Confirmação de Exclusão em Lote */}
      {showBulkDeleteModal && (
        <div
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, backdropFilter: 'blur(4px)', padding: '20px'
          }}
          onClick={(e) => e.target === e.currentTarget && setShowBulkDeleteModal(false)}
        >
          <div style={{
            background: 'white', borderRadius: '20px',
            width: '100%', maxWidth: '500px',
            boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
            animation: 'modalSlideIn 0.25s ease',
            overflow: 'hidden'
          }}>
            <div style={{ padding: '32px 28px 20px', textAlign: 'center' }}>
              <div style={{
                width: '64px', height: '64px', borderRadius: '50%',
                background: '#fee2e2', color: '#dc2626',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 16px'
              }}>
                <FiTrash2 size={32} />
              </div>
              <h4 style={{ margin: '0 0 8px', fontWeight: 700, fontSize: '1.25rem', color: '#1e293b' }}>
                Excluir Lote de Relatórios
              </h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#64748b' }}>
                Tem certeza que deseja excluir permanentemente os <strong>{selectedReportIds.length}</strong> relatórios selecionados?
              </p>
            </div>

            <div style={{ padding: '0 28px 20px', textAlign: 'center' }}>
              <div style={{
                padding: '12px 16px',
                background: '#fee2e2',
                border: '1px solid #f87171',
                borderRadius: '8px',
                fontSize: '0.85rem',
                color: '#991b1b'
              }}>
                ⚠️ Esta ação não pode ser desfeita. Todos os dados processados e registros desses relatórios serão removidos do sistema.
              </div>
            </div>

            <div style={{ padding: '16px 28px 24px', display: 'flex', justifyContent: 'center', gap: '12px' }}>
              <button
                type="button"
                className="btn-modern btn-modern-secondary"
                onClick={() => setShowBulkDeleteModal(false)}
                disabled={bulkDeleting}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn-modern btn-modern-danger"
                onClick={confirmBulkDelete}
                disabled={bulkDeleting}
              >
                <FiTrash2 className={`me-2 ${bulkDeleting ? 'spin-ico' : ''}`} size={16} />
                {bulkDeleting ? 'Excluindo Lote...' : 'Sim, Excluir Todos'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Erro */}
      {showErrorModal && (
        <div
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, backdropFilter: 'blur(4px)', padding: '20px'
          }}
          onClick={(e) => e.target === e.currentTarget && setShowErrorModal(false)}
        >
          <div style={{
            background: 'white', borderRadius: '20px',
            width: '100%', maxWidth: '450px',
            boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
            animation: 'modalSlideIn 0.25s ease',
            overflow: 'hidden'
          }}>
            <div style={{
              padding: '32px 28px 20px',
              textAlign: 'center'
            }}>
              <div style={{
                width: '64px', height: '64px', borderRadius: '50%',
                background: '#fee2e2', color: '#dc2626',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 16px'
              }}>
                <FiAlertTriangle size={32} />
              </div>
              <h4 style={{ margin: '0 0 8px', fontWeight: 700, fontSize: '1.25rem', color: '#1e293b' }}>
                {errorModalTitle}
              </h4>
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#64748b', lineHeight: '1.5' }}>
                {errorMessage}
              </p>
            </div>

            <div style={{
              padding: '16px 28px 24px',
              display: 'flex', justifyContent: 'center', gap: '12px'
            }}>
              <button
                type="button"
                className="btn-modern btn-modern-primary"
                onClick={() => setShowErrorModal(false)}
              >
                Entendido
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Processamento */}
      {showProcessingModal && (
        <div
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 10001, backdropFilter: 'blur(4px)', padding: '20px'
          }}
        >
          <div style={{
            background: 'white', borderRadius: '20px',
            width: '100%', maxWidth: '400px',
            boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
            animation: 'modalSlideIn 0.25s ease',
            overflow: 'hidden', textAlign: 'center',
            padding: '40px 28px'
          }}>
            <div style={{
              width: '64px', height: '64px', borderRadius: '50%',
              background: '#dbeafe', color: '#2563eb',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 20px'
            }}>
              <div className="spin-ico">
                <FiRefreshCw size={32} />
              </div>
            </div>
            <h5 style={{ margin: '0 0 8px', fontWeight: 700, fontSize: '1rem', color: '#1e293b' }}>
              Processando dados
            </h5>
            <p style={{ margin: 0, fontSize: '0.9rem', color: '#64748b' }}>
              {processingMessage}
            </p>
          </div>
        </div>
      )}

       {/* Modal de aviso de meta com relatório existente */}
      {showExistingReportWarning && (
        <div
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 10000, backdropFilter: 'blur(4px)', padding: '20px'
          }}
          onClick={(e) => e.target === e.currentTarget && setShowExistingReportWarning(false)}
        >
          <div style={{
            background: 'white', borderRadius: '20px',
            width: '100%', maxWidth: '550px', maxHeight: '85vh',
            boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
            animation: 'modalSlideIn 0.25s ease',
            display: 'flex', flexDirection: 'column',
            overflow: 'hidden'
          }}>
            {/* Header */}
            <div style={{
              padding: '24px 28px 20px',
              borderBottom: '1px solid var(--border)',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              flexShrink: 0
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{
                  width: '44px', height: '44px', borderRadius: '12px',
                  background: '#f59e0b', color: 'white',
                  display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                  <FiAlertTriangle size={20} />
                </div>
                <div>
                  <h5 style={{ margin: 0, fontWeight: 700, fontSize: '1rem' }}>
                    Atenção: Meta(s) com Relatório(s) Existente(s)
                  </h5>
                  <p style={{ margin: 0, fontSize: '0.78rem', color: 'var(--text-muted)' }}>
                    Foram encontrados relatórios cadastrados para as metas selecionadas
                  </p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setShowExistingReportWarning(false)}
                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', borderRadius: '8px' }}
              >
                <FiX size={20} color="var(--text-muted)" />
              </button>
            </div>

            {/* Body */}
            <div style={{ padding: '20px 28px', overflowY: 'auto', flex: 1 }}>
              <p style={{ fontSize: '0.85rem', color: '#475569', marginBottom: '16px' }}>
                As seguintes metas já possuem relatórios cadastrados. Você pode continuar criando novos relatórios ou verificar os existentes.
              </p>

              {existingReportWarnings.map((warning, idx) => (
                <div
                  key={idx}
                  style={{
                    padding: '14px 16px',
                    marginBottom: '10px',
                    borderRadius: '10px',
                    border: '1px solid #fbbf24',
                    background: '#fffbeb'
                  }}
                >
                  <div style={{ fontWeight: 600, fontSize: '0.85rem', color: '#92400e', marginBottom: '8px' }}>
                    <FiTarget size={14} style={{ marginRight: '6px', display: 'inline' }} />
                    {warning.goalLabel}
                  </div>
                  <div style={{ fontSize: '0.8rem', color: '#78350f' }}>
                    <div style={{ fontWeight: 600, marginBottom: '4px' }}>
                      Relatório(s) existente(s): {warning.reports.length}
                    </div>
                    {warning.reports.map((r, rIdx) => (
                      <div key={rIdx} style={{ padding: '4px 0', borderTop: '1px solid #fde68a' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <span>
                            <strong>{r.name}</strong>
                            <span style={{ marginLeft: '8px', fontSize: '0.75rem', color: '#92400e' }}>
                              ({String(r.period_start).slice(0, 10)} até {String(r.period_end).slice(0, 10)})
                            </span>
                          </span>
                          <span style={{
                            fontSize: '0.7rem',
                            padding: '2px 8px',
                            borderRadius: '4px',
                            background: r.finalized_at ? '#d1fae5' :
                                       r.status === 'completed' ? '#dbeafe' :
                                       r.status === 'failed' ? '#fee2e2' : '#f3f4f6',
                            color: r.finalized_at ? '#065f46' :
                                   r.status === 'completed' ? '#1e40af' :
                                   r.status === 'failed' ? '#991b1b' : '#6b7280',
                            fontWeight: 600
                          }}>
                            {r.finalized_at ? 'Finalizado' :
                             r.status === 'completed' ? 'Processado' :
                             r.status === 'processing' ? 'Processando' :
                             r.status === 'failed' ? 'Falhou' : 'Pendente'}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}

              <div style={{
                marginTop: '16px',
                padding: '12px 16px',
                background: '#fef3c7',
                border: '1px solid #fbbf24',
                borderRadius: '8px',
                fontSize: '0.78rem',
                color: '#92400e',
                lineHeight: '1.5'
              }}>
                <strong>Dica:</strong> Se você deseja atualizar um relatório existente, feche este aviso, cancele a criação e use o botão "Editar" no relatório desejado.
              </div>
            </div>

            {/* Footer */}
            <div style={{
              padding: '16px 28px 24px',
              borderTop: '1px solid var(--border)',
              display: 'flex', justifyContent: 'flex-end', gap: '12px',
              flexShrink: 0
            }}>
              <button
                type="button"
                className="btn-modern btn-modern-primary"
                onClick={() => setShowExistingReportWarning(false)}
              >
                <FiCheck className="me-1" />
                Entendido, Continuar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de verificação de regras de acréscimo */}
      {showAccrualModal && (
        <div
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 10000, backdropFilter: 'blur(4px)', padding: '20px'
          }}
          onClick={(e) => e.target === e.currentTarget && setShowAccrualModal(false)}
        >
          <div style={{
            background: 'white', borderRadius: '20px',
            width: '100%', maxWidth: '600px', maxHeight: '85vh',
            boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
            animation: 'modalSlideIn 0.25s ease',
            display: 'flex', flexDirection: 'column',
            overflow: 'hidden'
          }}>
            {/* Header */}
            <div style={{
              padding: '24px 28px 20px',
              borderBottom: '1px solid var(--border)',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              flexShrink: 0
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{
                  width: '44px', height: '44px', borderRadius: '12px',
                  background: '#f59e0b', color: 'white',
                  display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                  <FiAlertTriangle size={20} />
                </div>
                <div>
                  <h5 style={{ margin: 0, fontWeight: 700, fontSize: '1rem' }}>
                    Regras de Acréscimo Encontradas
                  </h5>
                  <p style={{ margin: 0, fontSize: '0.78rem', color: 'var(--text-muted)' }}>
                    Variáveis com regras de acréscimo vinculadas a relatórios do mesmo vendedor
                  </p>
                </div>
              </div>
            </div>

            {/* Body */}
            <div style={{ padding: '20px 28px', overflowY: 'auto', flex: 1 }}>
              <p style={{ fontSize: '0.85rem', color: '#475569', marginBottom: '16px' }}>
                As seguintes variáveis possuem regras de acréscimo apontando para relatórios do mesmo vendedor.
                Selecione quais você deseja substituir para que apontem para este novo relatório:
              </p>

              {accrualRules.map((rule) => {
                const willReplace = accrualRulesToReplace.includes(rule.rule_id);
                return (
                  <div
                    key={rule.rule_id}
                    style={{
                      padding: '14px 16px',
                      marginBottom: '10px',
                      borderRadius: '10px',
                      border: `1px solid ${willReplace ? '#22c55e' : '#e2e8f0'}`,
                      background: willReplace ? '#ecfdf5' : '#ffffff',
                      transition: 'all 0.15s ease'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px' }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px', flexWrap: 'wrap' }}>
                          <strong style={{ fontSize: '0.85rem', color: '#1e293b' }}>{rule.variable_name}</strong>
                          <span style={{
                            fontSize: '0.68rem', padding: '2px 8px', borderRadius: '4px',
                            background: '#dbeafe', color: '#1e40af', fontWeight: 600
                          }}>
                            Regra #{rule.rule_id}
                          </span>
                        </div>
                        <div style={{ fontSize: '0.78rem', color: '#64748b', lineHeight: '1.5' }}>
                          <div>Relatório atual: <strong>{rule.report_name}</strong></div>
                          <div>Vendedor: <strong>{rule.report_vendor_name}</strong></div>
                          {willReplace && (
                            <div style={{ marginTop: '6px', color: '#16a34a', fontWeight: 600, fontSize: '0.8rem' }}>
                              <FiArrowRight size={12} style={{ marginRight: 4 }} />
                              Será substituído para: <strong>{form.name}</strong>
                            </div>
                          )}
                        </div>
                      </div>
                      <select
                        value={willReplace ? 'replace' : 'keep'}
                        onChange={(e) => {
                          const wantsReplace = e.target.value === 'replace';
                          if (wantsReplace !== willReplace) {
                            toggleAccrualReplace(rule.rule_id);
                          }
                        }}
                        style={{
                          flexShrink: 0,
                          padding: '8px 12px',
                          borderRadius: '8px',
                          border: `1px solid ${willReplace ? '#22c55e' : '#cbd5e1'}`,
                          background: willReplace ? '#22c55e' : '#f8fafc',
                          color: willReplace ? '#ffffff' : '#475569',
                          cursor: 'pointer',
                          fontWeight: 600,
                          fontSize: '0.78rem',
                          outline: 'none',
                          minWidth: '130px'
                        }}
                      >
                        <option value="keep" style={{ background: '#f8fafc', color: '#475569' }}>Manter</option>
                        <option value="replace" style={{ background: '#22c55e', color: '#ffffff' }}>Substituir</option>
                      </select>
                    </div>
                  </div>
                );
              })}

              <div style={{
                marginTop: '16px',
                padding: '12px 16px',
                background: '#fef3c7',
                border: '1px solid #fbbf24',
                borderRadius: '8px',
                fontSize: '0.78rem',
                color: '#92400e',
                lineHeight: '1.5'
              }}>
                <strong>Atenção:</strong> As regras marcadas como "Substituir" terão a referência do relatório alterada
                para este novo relatório após o salvamento. As demais permanecerão inalteradas.
              </div>
            </div>

            {/* Footer */}
            <div style={{
              padding: '16px 28px 24px',
              borderTop: '1px solid var(--border)',
              display: 'flex', justifyContent: 'flex-end', gap: '12px',
              flexShrink: 0
            }}>
              <button
                type="button"
                className="btn-modern btn-modern-secondary"
                onClick={() => {
                  setShowAccrualModal(false);
                  pendingAccrualPayloadRef.current = null;
                }}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn-modern btn-modern-primary"
                onClick={handleAccrualSave}
              >
                <FiSave className="me-1" />
                Salvar Relatório
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Agendamento de Sincronização */}
      {showSyncScheduleModal && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(15, 23, 42, 0.65)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            backdropFilter: 'blur(4px)',
            padding: '20px'
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget && !savingSyncSchedule) {
              setShowSyncScheduleModal(false);
            }
          }}
        >
          <div
            style={{
              background: '#ffffff',
              borderRadius: '20px',
              width: '100%',
              maxWidth: '880px',
              maxHeight: '90vh',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
              animation: 'modalSlideIn 0.22s ease-out',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden'
            }}
          >
            {/* Header */}
            <div
              style={{
                padding: '20px 24px',
                borderBottom: '1px solid #e2e8f0',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: '#f8fafc',
                flexShrink: 0
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div
                  style={{
                    width: '42px',
                    height: '42px',
                    borderRadius: '12px',
                    backgroundColor: '#eff6ff',
                    color: '#2563eb',
                    border: '1px solid #bfdbfe',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <FiClock size={22} />
                </div>
                <div>
                  <h5 style={{ margin: 0, fontWeight: 700, fontSize: '1.05rem', color: '#0f172a' }}>
                    Agendamento de Sincronização de Relatórios
                  </h5>
                  <p style={{ margin: 0, fontSize: '0.78rem', color: '#64748b' }}>
                    Configure rotinas periódicas com seleção de horários, dias e filtros de relatórios
                  </p>
                </div>
              </div>

              <button
                type="button"
                onClick={() => setShowSyncScheduleModal(false)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#94a3b8',
                  cursor: 'pointer',
                  padding: '6px',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <FiX size={20} />
              </button>
            </div>

            {/* Sub-Navigation Tabs */}
            <div
              style={{
                display: 'flex',
                gap: '8px',
                padding: '12px 24px 0',
                borderBottom: '1px solid #e2e8f0',
                backgroundColor: '#ffffff',
                flexShrink: 0
              }}
            >
              <button
                type="button"
                onClick={() => {
                  setSyncScheduleSubTab('list');
                  setScheduleActionFeedback(null);
                }}
                style={{
                  padding: '10px 16px',
                  background: 'transparent',
                  border: 'none',
                  borderBottom: syncScheduleSubTab === 'list' ? '3px solid #2563eb' : '3px solid transparent',
                  color: syncScheduleSubTab === 'list' ? '#2563eb' : '#64748b',
                  fontWeight: syncScheduleSubTab === 'list' ? 700 : 500,
                  fontSize: '0.85rem',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.15s ease'
                }}
              >
                <span>Rotinas Agendadas</span>
                <span
                  style={{
                    background: syncScheduleSubTab === 'list' ? '#eff6ff' : '#f1f5f9',
                    color: syncScheduleSubTab === 'list' ? '#2563eb' : '#64748b',
                    borderRadius: '12px',
                    padding: '2px 8px',
                    fontSize: '0.72rem',
                    fontWeight: 700
                  }}
                >
                  {syncSchedules.length}
                </span>
              </button>

              <button
                type="button"
                onClick={() => openNewScheduleForm()}
                style={{
                  padding: '10px 16px',
                  background: 'transparent',
                  border: 'none',
                  borderBottom: syncScheduleSubTab === 'form' ? '3px solid #2563eb' : '3px solid transparent',
                  color: syncScheduleSubTab === 'form' ? '#2563eb' : '#64748b',
                  fontWeight: syncScheduleSubTab === 'form' ? 700 : 500,
                  fontSize: '0.85rem',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  transition: 'all 0.15s ease'
                }}
              >
                <FiPlus size={16} />
                <span>{syncScheduleForm.id ? `Editar Rotina #${syncScheduleForm.id}` : 'Nova Rotina'}</span>
              </button>
            </div>

            {/* Body */}
            <div style={{ padding: '20px 24px', overflowY: 'auto', flex: 1, backgroundColor: '#f8fafc' }}>
              {scheduleActionFeedback && (
                <div
                  className={`alert alert-${scheduleActionFeedback.type} py-2 px-3 mb-3`}
                  style={{ fontSize: '0.84rem', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                  <span>{scheduleActionFeedback.text}</span>
                  <button
                    type="button"
                    style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: 'inherit' }}
                    onClick={() => setScheduleActionFeedback(null)}
                  >
                    <FiX size={14} />
                  </button>
                </div>
              )}

              {syncScheduleSubTab === 'list' ? (
                /* TAB 1: LIST OF SCHEDULES */
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                    <span style={{ fontSize: '0.85rem', color: '#64748b' }}>
                      O sincronizador em segundo plano verifica e executa automaticamente essas rotinas nos dias e horários programados.
                    </span>
                    <button
                      type="button"
                      className="btn-modern btn-modern-primary"
                      onClick={() => openNewScheduleForm()}
                      style={{ fontSize: '0.8rem', padding: '6px 14px', flexShrink: 0 }}
                    >
                      <FiPlus size={14} className="me-1" /> Nova Rotina
                    </button>
                  </div>

                  {loadingSyncSchedules && syncSchedules.length === 0 ? (
                    <div className="text-center py-5">
                      <Loading />
                      <p className="mt-2 text-muted" style={{ fontSize: '0.85rem' }}>Carregando rotinas de sincronização...</p>
                    </div>
                  ) : syncSchedules.length === 0 ? (
                    <div
                      style={{
                        background: '#ffffff',
                        border: '2px dashed #cbd5e1',
                        borderRadius: '16px',
                        padding: '40px 20px',
                        textAlign: 'center'
                      }}
                    >
                      <div
                        style={{
                          width: '56px',
                          height: '56px',
                          borderRadius: '50%',
                          backgroundColor: '#eff6ff',
                          color: '#3b82f6',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginBottom: '14px'
                        }}
                      >
                        <FiClock size={28} />
                      </div>
                      <h6 style={{ fontWeight: 700, color: '#1e293b', marginBottom: '6px' }}>
                        Nenhuma rotina de sincronização cadastrada
                      </h6>
                      <p style={{ color: '#64748b', fontSize: '0.84rem', maxWidth: '420px', margin: '0 auto 18px' }}>
                        Crie agendamentos para atualizar automaticamente os relatórios em horários fixos durante a semana (por exemplo, 08:00, 13:00 e 18:00).
                      </p>
                      <button
                        type="button"
                        className="btn-modern btn-modern-primary"
                        onClick={() => openNewScheduleForm()}
                      >
                        <FiPlus size={16} className="me-1" /> Criar Primeiro Agendamento
                      </button>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                      {syncSchedules.map((s) => {
                        let times = [];
                        try {
                          if (Array.isArray(s.scheduled_time)) {
                            times = s.scheduled_time;
                          } else if (typeof s.scheduled_time === 'string' && s.scheduled_time !== 'Array') {
                            times = s.scheduled_time.startsWith('[')
                              ? JSON.parse(s.scheduled_time)
                              : s.scheduled_time.split(',').map(t => t.trim()).filter(Boolean);
                          }
                        } catch (e) {
                          times = [];
                        }

                        let days = [];
                        try {
                          if (Array.isArray(s.days_of_week)) {
                            days = s.days_of_week;
                          } else if (typeof s.days_of_week === 'string' && s.days_of_week !== 'Array') {
                            if (s.days_of_week === 'all') {
                              days = [0, 1, 2, 3, 4, 5, 6];
                            } else if (s.days_of_week.startsWith('[')) {
                              days = JSON.parse(s.days_of_week);
                            } else {
                              days = s.days_of_week.split(',').map(d => d.trim()).filter(Boolean);
                            }
                          }
                        } catch (e) {
                          days = [];
                        }

                        const rTypes = s.report_types || {};
                        const isRunLoading = runningScheduleId === s.id;
                        const isConfirmingDelete = scheduleDeleteConfirm?.id === s.id;

                        return (
                          <div
                            key={s.id}
                            style={{
                              background: '#ffffff',
                              borderRadius: '14px',
                              border: `1px solid ${s.is_active ? '#bfdbfe' : '#e2e8f0'}`,
                              boxShadow: '0 2px 4px rgba(0,0,0,0.03)',
                              padding: '16px 20px',
                              transition: 'all 0.15s ease'
                            }}
                          >
                            {/* Card Top */}
                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px', marginBottom: '12px' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <span
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                    fontSize: '0.72rem',
                                    fontWeight: 700,
                                    padding: '3px 10px',
                                    borderRadius: '12px',
                                    backgroundColor: s.is_active ? '#ecfdf5' : '#f1f5f9',
                                    color: s.is_active ? '#059669' : '#64748b',
                                    border: `1px solid ${s.is_active ? '#a7f3d0' : '#cbd5e1'}`
                                  }}
                                >
                                  <span
                                    style={{
                                      width: '7px',
                                      height: '7px',
                                      borderRadius: '50%',
                                      backgroundColor: s.is_active ? '#10b981' : '#94a3b8'
                                    }}
                                  />
                                  {s.is_active ? 'Ativo' : 'Pausado'}
                                </span>
                                <strong style={{ fontSize: '0.98rem', color: '#0f172a' }}>{s.name}</strong>
                              </div>

                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {/* Toggle Active */}
                                <label
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    cursor: 'pointer',
                                    fontSize: '0.75rem',
                                    color: '#475569',
                                    fontWeight: 500,
                                    margin: 0
                                  }}
                                  title={s.is_active ? 'Clique para desativar' : 'Clique para ativar'}
                                >
                                  <input
                                    type="checkbox"
                                    checked={!!s.is_active}
                                    onChange={() => handleToggleSchedule(s.id)}
                                    style={{ cursor: 'pointer', width: '16px', height: '16px' }}
                                  />
                                  <span>{s.is_active ? 'Ativado' : 'Pausado'}</span>
                                </label>
                              </div>
                            </div>

                            {/* Card Meta details */}
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center', marginBottom: '12px' }}>
                              {/* Times */}
                              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
                                <span style={{ fontSize: '0.75rem', color: '#64748b', fontWeight: 600 }}>Horários:</span>
                                {times.length > 0 ? (
                                  times.map((t, idx) => (
                                    <span
                                      key={idx}
                                      style={{
                                        fontSize: '0.72rem',
                                        fontWeight: 700,
                                        padding: '2px 8px',
                                        borderRadius: '6px',
                                        backgroundColor: '#eff6ff',
                                        color: '#1d4ed8',
                                        border: '1px solid #bfdbfe'
                                      }}
                                    >
                                      🕒 {t}
                                    </span>
                                  ))
                                ) : (
                                  <span style={{ fontSize: '0.72rem', color: '#94a3b8', fontStyle: 'italic' }}>Nenhum horário</span>
                                )}
                              </div>

                              {/* Separator dot */}
                              <span style={{ color: '#cbd5e1' }}>•</span>

                              {/* Days */}
                              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
                                <span style={{ fontSize: '0.75rem', color: '#64748b', fontWeight: 600 }}>Dias:</span>
                                {DAYS_OF_WEEK_OPTIONS.map((d) => {
                                  const isSelected = days.some(
                                    sel => Number(sel) === d.id || String(sel).toLowerCase() === d.label.toLowerCase()
                                  );
                                  return (
                                    <span
                                      key={d.id}
                                      style={{
                                        fontSize: '0.68rem',
                                        padding: '1px 6px',
                                        borderRadius: '4px',
                                        fontWeight: isSelected ? 700 : 400,
                                        backgroundColor: isSelected ? '#3b82f6' : '#f1f5f9',
                                        color: isSelected ? '#ffffff' : '#94a3b8'
                                      }}
                                    >
                                      {d.label}
                                    </span>
                                  );
                                })}
                              </div>

                              {/* Separator dot */}
                              <span style={{ color: '#cbd5e1' }}>•</span>

                              {/* Matching reports count */}
                              <span
                                style={{
                                  fontSize: '0.72rem',
                                  fontWeight: 700,
                                  padding: '2px 8px',
                                  borderRadius: '6px',
                                  backgroundColor: '#f0fdf4',
                                  color: '#15803d',
                                  border: '1px solid #bbf7d0'
                                }}
                              >
                                ⚡ {s.matching_reports_count ?? 0} relatório(s) vinculados
                              </span>

                              {/* Separator dot */}
                              <span style={{ color: '#cbd5e1' }}>•</span>

                              {/* Execution count badge */}
                              <span
                                style={{
                                  fontSize: '0.72rem',
                                  fontWeight: 700,
                                  padding: '2px 8px',
                                  borderRadius: '6px',
                                  backgroundColor: (s.execution_count > 0) ? '#f5f3ff' : '#f8fafc',
                                  color: (s.execution_count > 0) ? '#7c3aed' : '#64748b',
                                  border: `1px solid ${(s.execution_count > 0) ? '#ddd6fe' : '#e2e8f0'}`
                                }}
                                title="Quantidade total de vezes que esta rotina foi executada"
                              >
                                🔄 {(s.execution_count ?? 0) === 1 ? '1 execução' : `${s.execution_count ?? 0} execuções`}
                              </span>
                            </div>

                            {/* Criteria pills summary */}
                            <div
                              style={{
                                background: '#f8fafc',
                                borderRadius: '8px',
                                padding: '8px 12px',
                                fontSize: '0.74rem',
                                color: '#475569',
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '12px',
                                marginBottom: '12px'
                              }}
                            >
                              <div>
                                <span style={{ color: '#94a3b8', fontWeight: 600 }}>Classificação: </span>
                                <strong>{rTypes.classifications?.length > 0 ? rTypes.classifications.join(', ') : 'Todas'}</strong>
                              </div>
                              <div>
                                <span style={{ color: '#94a3b8', fontWeight: 600 }}>Subtipo: </span>
                                <strong>{rTypes.subtypes?.length > 0 ? rTypes.subtypes.join(', ') : 'Todos'}</strong>
                              </div>
                              <div>
                                <span style={{ color: '#94a3b8', fontWeight: 600 }}>Alvo: </span>
                                <strong>{rTypes.target_types?.length > 0 ? rTypes.target_types.join(', ') : 'Todos'}</strong>
                              </div>
                              <div>
                                <span style={{ color: '#94a3b8', fontWeight: 600 }}>Filiais: </span>
                                <strong>{rTypes.branches?.length > 0 ? rTypes.branches.join(', ') : 'Todas'}</strong>
                              </div>
                              <div>
                                <span style={{ color: '#94a3b8', fontWeight: 600 }}>Período: </span>
                                <strong>
                                  {rTypes.period_mode === 'all_open'
                                    ? 'Todos em Aberto'
                                    : rTypes.period_mode === 'specific_month'
                                      ? `Mês ${String(rTypes.reference_month || '').padStart(2, '0')}/${rTypes.reference_year}`
                                      : 'Mês Atual'}
                                </strong>
                              </div>
                            </div>

                            {/* Execution Log & Actions */}
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', flexWrap: 'wrap', borderTop: '1px solid #f1f5f9', paddingTop: '10px' }}>
                              <div style={{ fontSize: '0.75rem', color: '#475569', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                <div>
                                  {s.last_run_at ? (
                                    <span>
                                      Última execução: <strong style={{ color: '#0f172a' }}>{new Date(s.last_run_at).toLocaleString('pt-BR')}</strong>
                                      {s.last_log && <span style={{ color: '#64748b' }}> — {s.last_log}</span>}
                                    </span>
                                  ) : (
                                    <span style={{ fontStyle: 'italic', color: '#94a3b8' }}>Ainda não executado</span>
                                  )}
                                </div>
                                <span style={{ color: '#cbd5e1' }}>•</span>
                                <div>
                                  Total de atualizações: <strong style={{ color: '#1e293b' }}>{s.execution_count ?? 0}</strong>
                                </div>
                              </div>

                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <button
                                  type="button"
                                  className="btn-modern btn-modern-primary"
                                  onClick={() => handleRunScheduleNow(s.id)}
                                  disabled={isRunLoading}
                                  style={{ fontSize: '0.76rem', padding: '4px 12px' }}
                                  title="Disparar sincronização imediata desses relatórios"
                                >
                                  {isRunLoading ? (
                                    <span
                                      className="spinner-border spinner-border-sm me-1"
                                      role="status"
                                      aria-hidden="true"
                                      style={{ width: '11px', height: '11px', borderWidth: '1.5px', display: 'inline-block', verticalAlign: '-1px' }}
                                    />
                                  ) : (
                                    <FiRefreshCw size={12} className="me-1" />
                                  )}
                                  {isRunLoading ? 'Disparando...' : 'Executar Agora'}
                                </button>

                                {canManage && (
                                  <>
                                    <button
                                      type="button"
                                      className="btn-modern btn-modern-secondary"
                                      onClick={() => openEditScheduleForm(s)}
                                      style={{ fontSize: '0.76rem', padding: '4px 10px' }}
                                      title="Editar rotina"
                                    >
                                      <FiEdit2 size={12} />
                                    </button>

                                    <button
                                      type="button"
                                      className="btn-modern btn-modern-outline-danger"
                                      onClick={() => setScheduleDeleteConfirm(s)}
                                      style={{ fontSize: '0.76rem', padding: '4px 10px' }}
                                      title="Excluir rotina"
                                    >
                                      <FiTrash2 size={12} />
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>

                            {/* Delete confirm inline prompt */}
                            {isConfirmingDelete && (
                              <div
                                style={{
                                  marginTop: '12px',
                                  padding: '10px 14px',
                                  borderRadius: '8px',
                                  backgroundColor: '#fef2f2',
                                  border: '1px solid #fecaca',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  gap: '10px'
                                }}
                              >
                                <span style={{ fontSize: '0.78rem', color: '#991b1b', fontWeight: 600 }}>
                                  Deseja realmente excluir este agendamento?
                                </span>
                                <div style={{ display: 'flex', gap: '6px' }}>
                                  <button
                                    type="button"
                                    className="btn-modern btn-modern-secondary"
                                    onClick={() => setScheduleDeleteConfirm(null)}
                                    style={{ fontSize: '0.72rem', padding: '3px 8px' }}
                                  >
                                    Cancelar
                                  </button>
                                  <button
                                    type="button"
                                    className="btn-modern btn-modern-danger"
                                    onClick={() => handleDeleteSchedule(s.id)}
                                    style={{ fontSize: '0.72rem', padding: '3px 8px' }}
                                  >
                                    Confirmar Exclusão
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              ) : (
                /* TAB 2: FORM (NEW / EDIT) */
                <form onSubmit={handleSaveSchedule}>
                  <div
                    style={{
                      background: '#ffffff',
                      borderRadius: '16px',
                      border: '1px solid #e2e8f0',
                      padding: '20px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '20px'
                    }}
                  >
                    {/* 1. Nome da Rotina */}
                    <div className="form-group-modern" style={{ marginBottom: '16px' }}>
                      <label style={{ display: 'block', fontWeight: 600, fontSize: '0.85rem', color: '#1e293b', marginBottom: '6px' }}>
                        Nome da Rotina de Sincronização *
                      </label>
                      <input
                        type="text"
                        className="form-control-modern"
                        placeholder="Ex: Atualização Diária - Vendedores e Bijou"
                        value={syncScheduleForm.name}
                        onChange={(e) => setSyncScheduleForm({ ...syncScheduleForm, name: e.target.value })}
                        style={{
                          width: '100%',
                          fontSize: '0.88rem',
                          height: '42px',
                          border: '1px solid #cbd5e1',
                          borderRadius: '10px',
                          padding: '10px 14px',
                          backgroundColor: '#ffffff',
                          transition: 'all 0.2s ease',
                          outline: 'none'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#3b82f6';
                          e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.15)';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#cbd5e1';
                          e.target.style.boxShadow = 'none';
                        }}
                        required
                      />
                    </div>

                    {/* 2. Horários de Execução */}
                    <div>
                      <label style={{ display: 'block', fontWeight: 600, fontSize: '0.85rem', color: '#1e293b', marginBottom: '4px' }}>
                        Horários de Execução (Brasília) *
                      </label>
                      <p style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: '8px' }}>
                        Adicione um ou mais horários em que o sincronizador deve acionar a atualização.
                      </p>

                      {/* Chips container */}
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center', marginBottom: '10px' }}>
                        {syncScheduleForm.scheduled_times.length === 0 ? (
                          <span style={{ fontSize: '0.78rem', color: '#94a3b8', fontStyle: 'italic' }}>
                            Nenhum horário adicionado. Selecione ou digite abaixo.
                          </span>
                        ) : (
                          syncScheduleForm.scheduled_times.map((timeStr) => (
                            <span
                              key={timeStr}
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px',
                                background: '#eff6ff',
                                color: '#1d4ed8',
                                border: '1px solid #bfdbfe',
                                borderRadius: '16px',
                                padding: '4px 10px',
                                fontSize: '0.8rem',
                                fontWeight: 700
                              }}
                            >
                              <FiClock size={12} />
                              <span>{timeStr}</span>
                              <button
                                type="button"
                                onClick={() => handleRemoveScheduleTime(timeStr)}
                                style={{
                                  background: 'transparent',
                                  border: 'none',
                                  color: '#3b82f6',
                                  cursor: 'pointer',
                                  padding: 0,
                                  fontSize: '0.8rem',
                                  lineHeight: 1
                                }}
                                title="Remover horário"
                              >
                                ✕
                              </button>
                            </span>
                          ))
                        )}
                      </div>

                      {/* Time input + Add button + Presets */}
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                        <input
                          type="time"
                          value={syncScheduleForm.timeInput}
                          onChange={(e) => setSyncScheduleForm({ ...syncScheduleForm, timeInput: e.target.value })}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              handleAddScheduleTime();
                            }
                          }}
                          style={{
                            padding: '6px 12px',
                            borderRadius: '8px',
                            border: '1px solid #cbd5e1',
                            fontSize: '0.85rem',
                            outline: 'none',
                            width: '130px'
                          }}
                        />
                        <button
                          type="button"
                          className="btn-modern btn-modern-secondary"
                          onClick={() => handleAddScheduleTime()}
                          style={{ fontSize: '0.8rem', padding: '6px 12px' }}
                        >
                          <FiPlus size={14} className="me-1" /> Adicionar
                        </button>

                        <span style={{ fontSize: '0.75rem', color: '#94a3b8', margin: '0 4px' }}>ou atalhos:</span>

                        {PRESET_TIMES.map((preset) => {
                          const isAdded = syncScheduleForm.scheduled_times.includes(preset);
                          return (
                            <button
                              key={preset}
                              type="button"
                              onClick={() => isAdded ? handleRemoveScheduleTime(preset) : handleAddScheduleTime(preset)}
                              style={{
                                fontSize: '0.72rem',
                                padding: '4px 8px',
                                borderRadius: '6px',
                                border: `1px solid ${isAdded ? '#3b82f6' : '#e2e8f0'}`,
                                backgroundColor: isAdded ? '#3b82f6' : '#ffffff',
                                color: isAdded ? '#ffffff' : '#64748b',
                                cursor: 'pointer',
                                fontWeight: isAdded ? 700 : 500
                              }}
                            >
                              {preset}
                            </button>
                          );
                        })}
                      </div>
                    </div>

                    {/* 3. Dias da Semana */}
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                        <label style={{ fontWeight: 600, fontSize: '0.85rem', color: '#1e293b', margin: 0 }}>
                          Dias da Semana *
                        </label>
                        <div style={{ display: 'flex', gap: '6px' }}>
                          <button
                            type="button"
                            onClick={() => setSyncScheduleForm(prev => ({ ...prev, days_of_week: [1, 2, 3, 4, 5] }))}
                            style={{
                              fontSize: '0.72rem',
                              padding: '2px 8px',
                              borderRadius: '4px',
                              border: '1px solid #cbd5e1',
                              background: '#f8fafc',
                              cursor: 'pointer',
                              color: '#475569'
                            }}
                          >
                            Seg a Sex
                          </button>
                          <button
                            type="button"
                            onClick={() => setSyncScheduleForm(prev => ({ ...prev, days_of_week: [0, 1, 2, 3, 4, 5, 6] }))}
                            style={{
                              fontSize: '0.72rem',
                              padding: '2px 8px',
                              borderRadius: '4px',
                              border: '1px solid #cbd5e1',
                              background: '#f8fafc',
                              cursor: 'pointer',
                              color: '#475569'
                            }}
                          >
                            Todos os Dias
                          </button>
                          <button
                            type="button"
                            onClick={() => setSyncScheduleForm(prev => ({ ...prev, days_of_week: [0, 6] }))}
                            style={{
                              fontSize: '0.72rem',
                              padding: '2px 8px',
                              borderRadius: '4px',
                              border: '1px solid #cbd5e1',
                              background: '#f8fafc',
                              cursor: 'pointer',
                              color: '#475569'
                            }}
                          >
                            Fins de Semana
                          </button>
                        </div>
                      </div>

                      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                        {DAYS_OF_WEEK_OPTIONS.map((d) => {
                          const isSelected = syncScheduleForm.days_of_week.includes(d.id);
                          return (
                            <button
                              key={d.id}
                              type="button"
                              onClick={() => handleToggleScheduleDay(d.id)}
                              style={{
                                padding: '8px 14px',
                                borderRadius: '10px',
                                border: `1px solid ${isSelected ? '#2563eb' : '#cbd5e1'}`,
                                backgroundColor: isSelected ? '#2563eb' : '#ffffff',
                                color: isSelected ? '#ffffff' : '#334155',
                                fontWeight: isSelected ? 700 : 500,
                                fontSize: '0.82rem',
                                cursor: 'pointer',
                                transition: 'all 0.15s ease'
                              }}
                            >
                              {d.name}
                            </button>
                          );
                        })}
                      </div>
                    </div>

                    <hr style={{ margin: '4px 0', borderColor: '#f1f5f9' }} />

                    {/* 4. Filtros e Tipos de Relatórios */}
                    <div>
                      <h6 style={{ fontWeight: 700, fontSize: '0.9rem', color: '#0f172a', marginBottom: '4px' }}>
                        Critérios de Relatórios para Atualização
                      </h6>
                      <p style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: '14px' }}>
                        Defina quais relatórios serão abrangidos por este agendamento. Se deixar os filtros desmarcados, abrangerá todos da respectiva categoria.
                      </p>

                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px' }}>
                        {/* Classificação */}
                        <div style={{ background: '#f8fafc', padding: '12px 14px', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
                          <label style={{ display: 'block', fontWeight: 600, fontSize: '0.78rem', color: '#334155', marginBottom: '6px' }}>
                            Classificação da Meta:
                          </label>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                            {[
                              { id: 'vendedor', label: 'Vendedor' },
                              { id: 'bijou', label: 'Bijou' },
                              { id: 'operador_caixa', label: 'Operador de Caixa' }
                            ].map(opt => {
                              const active = syncScheduleForm.classifications.includes(opt.id);
                              return (
                                <button
                                  key={opt.id}
                                  type="button"
                                  onClick={() => handleToggleClassification(opt.id)}
                                  style={{
                                    fontSize: '0.74rem',
                                    padding: '4px 10px',
                                    borderRadius: '6px',
                                    border: `1px solid ${active ? '#3b82f6' : '#cbd5e1'}`,
                                    background: active ? '#eff6ff' : '#ffffff',
                                    color: active ? '#1d4ed8' : '#475569',
                                    fontWeight: active ? 700 : 500,
                                    cursor: 'pointer'
                                  }}
                                >
                                  {opt.label} {active && '✓'}
                                </button>
                              );
                            })}
                          </div>
                          <span style={{ fontSize: '0.68rem', color: '#94a3b8', marginTop: '4px', display: 'block' }}>
                            {syncScheduleForm.classifications.length === 0 ? 'Todas as classificações selecionadas' : `${syncScheduleForm.classifications.length} selecionada(s)`}
                          </span>
                        </div>

                        {/* Subtipo de Meta */}
                        <div style={{ background: '#f8fafc', padding: '12px 14px', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
                          <label style={{ display: 'block', fontWeight: 600, fontSize: '0.78rem', color: '#334155', marginBottom: '6px' }}>
                            Subtipo de Meta:
                          </label>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                            {[
                              { id: 'vendas', label: 'Vendas' },
                              { id: 'produtos_destaque', label: 'Prod. Destaque' },
                              { id: 'clientes_positivados', label: 'Clientes Positivados' }
                            ].map(opt => {
                              const active = syncScheduleForm.subtypes.includes(opt.id);
                              return (
                                <button
                                  key={opt.id}
                                  type="button"
                                  onClick={() => handleToggleSubtype(opt.id)}
                                  style={{
                                    fontSize: '0.74rem',
                                    padding: '4px 10px',
                                    borderRadius: '6px',
                                    border: `1px solid ${active ? '#3b82f6' : '#cbd5e1'}`,
                                    background: active ? '#eff6ff' : '#ffffff',
                                    color: active ? '#1d4ed8' : '#475569',
                                    fontWeight: active ? 700 : 500,
                                    cursor: 'pointer'
                                  }}
                                >
                                  {opt.label} {active && '✓'}
                                </button>
                              );
                            })}
                          </div>
                          <span style={{ fontSize: '0.68rem', color: '#94a3b8', marginTop: '4px', display: 'block' }}>
                            {syncScheduleForm.subtypes.length === 0 ? 'Todos os subtipos selecionados' : `${syncScheduleForm.subtypes.length} selecionado(s)`}
                          </span>
                        </div>

                        {/* Tipo de Alvo */}
                        <div style={{ background: '#f8fafc', padding: '12px 14px', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
                          <label style={{ display: 'block', fontWeight: 600, fontSize: '0.78rem', color: '#334155', marginBottom: '6px' }}>
                            Tipo de Alvo da Meta:
                          </label>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                            {[
                              { id: 'vendor', label: 'Vendedor' },
                              { id: 'employee', label: 'Funcionário' },
                              { id: 'branch', label: 'Filial' },
                              { id: 'general', label: 'Geral' }
                            ].map(opt => {
                              const active = syncScheduleForm.target_types.includes(opt.id);
                              return (
                                <button
                                  key={opt.id}
                                  type="button"
                                  onClick={() => handleToggleTargetType(opt.id)}
                                  style={{
                                    fontSize: '0.74rem',
                                    padding: '4px 10px',
                                    borderRadius: '6px',
                                    border: `1px solid ${active ? '#3b82f6' : '#cbd5e1'}`,
                                    background: active ? '#eff6ff' : '#ffffff',
                                    color: active ? '#1d4ed8' : '#475569',
                                    fontWeight: active ? 700 : 500,
                                    cursor: 'pointer'
                                  }}
                                >
                                  {opt.label} {active && '✓'}
                                </button>
                              );
                            })}
                          </div>
                          <span style={{ fontSize: '0.68rem', color: '#94a3b8', marginTop: '4px', display: 'block' }}>
                            {syncScheduleForm.target_types.length === 0 ? 'Todos os tipos de alvo selecionados' : `${syncScheduleForm.target_types.length} selecionado(s)`}
                          </span>
                        </div>

                        {/* Modo de Período */}
                        <div style={{ background: '#f8fafc', padding: '12px 14px', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
                          <label style={{ display: 'block', fontWeight: 600, fontSize: '0.78rem', color: '#334155', marginBottom: '6px' }}>
                            Período Abrangido:
                          </label>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.76rem', cursor: 'pointer', margin: 0 }}>
                              <input
                                type="radio"
                                name="period_mode"
                                value="current_month"
                                checked={syncScheduleForm.period_mode === 'current_month'}
                                onChange={() => handleChangePeriodMode('current_month')}
                              />
                              <span><strong>Mês Atual</strong> (Dinâmico: mês em vigor na data da execução)</span>
                            </label>

                            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.76rem', cursor: 'pointer', margin: 0 }}>
                              <input
                                type="radio"
                                name="period_mode"
                                value="specific_month"
                                checked={syncScheduleForm.period_mode === 'specific_month'}
                                onChange={() => handleChangePeriodMode('specific_month')}
                              />
                              <span><strong>Mês Específico</strong></span>
                            </label>

                            {syncScheduleForm.period_mode === 'specific_month' && (
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '20px', marginTop: '2px', marginBottom: '4px' }}>
                                <select
                                  className="form-control-modern"
                                  style={{
                                    width: '135px',
                                    fontSize: '0.78rem',
                                    height: '32px',
                                    padding: '4px 10px',
                                    borderRadius: '8px',
                                    border: '1px solid #cbd5e1',
                                    backgroundColor: '#ffffff',
                                    cursor: 'pointer'
                                  }}
                                  value={syncScheduleForm.reference_month}
                                  onChange={(e) => setSyncScheduleForm(prev => ({ ...prev, reference_month: parseInt(e.target.value, 10) }))}
                                >
                                  {MESES.map(m => (
                                    <option key={m.v} value={m.v}>{m.n}</option>
                                  ))}
                                </select>
                                <input
                                  type="number"
                                  className="form-control-modern"
                                  style={{
                                    width: '85px',
                                    fontSize: '0.78rem',
                                    height: '32px',
                                    padding: '4px 10px',
                                    borderRadius: '8px',
                                    border: '1px solid #cbd5e1',
                                    backgroundColor: '#ffffff'
                                  }}
                                  value={syncScheduleForm.reference_year}
                                  onChange={(e) => setSyncScheduleForm(prev => ({ ...prev, reference_year: parseInt(e.target.value, 10) }))}
                                  min={2020}
                                  max={2040}
                                />
                              </div>
                            )}

                            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.76rem', cursor: 'pointer', margin: 0 }}>
                              <input
                                type="radio"
                                name="period_mode"
                                value="all_open"
                                checked={syncScheduleForm.period_mode === 'all_open'}
                                onChange={() => handleChangePeriodMode('all_open')}
                              />
                              <span><strong>Todos em Aberto</strong> (Qualquer mês pendente)</span>
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Filiais */}
                      <div style={{ marginTop: '14px', background: '#f8fafc', padding: '12px 14px', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                          <label style={{ fontWeight: 600, fontSize: '0.78rem', color: '#334155', margin: 0 }}>
                            Filiais Específicas (opcional):
                          </label>
                          {syncScheduleForm.branches.length > 0 && (
                            <button
                              type="button"
                              onClick={() => setSyncScheduleForm(prev => ({ ...prev, branches: [] }))}
                              style={{ background: 'transparent', border: 'none', color: '#2563eb', fontSize: '0.72rem', cursor: 'pointer', textDecoration: 'underline' }}
                            >
                              Limpar (Todas as Filiais)
                            </button>
                          )}
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', maxHeight: '100px', overflowY: 'auto' }}>
                          {branches.map(b => {
                            const isSelected = syncScheduleForm.branches.includes(b.id);
                            return (
                              <button
                                key={b.id}
                                type="button"
                                onClick={() => handleToggleScheduleBranch(b.id)}
                                style={{
                                  fontSize: '0.72rem',
                                  padding: '3px 8px',
                                  borderRadius: '6px',
                                  border: `1px solid ${isSelected ? '#2563eb' : '#cbd5e1'}`,
                                  background: isSelected ? '#2563eb' : '#ffffff',
                                  color: isSelected ? '#ffffff' : '#475569',
                                  fontWeight: isSelected ? 700 : 400,
                                  cursor: 'pointer'
                                }}
                              >
                                {b.id} {isSelected ? '✓' : ''}
                              </button>
                            );
                          })}
                        </div>
                        <span style={{ fontSize: '0.68rem', color: '#94a3b8', marginTop: '4px', display: 'block' }}>
                          {syncScheduleForm.branches.length === 0 ? 'Todas as filiais abrangidas' : `${syncScheduleForm.branches.length} filial(is) filtrada(s)`}
                        </span>
                      </div>
                    </div>

                    {/* 5. Painel de Estimativa em Tempo Real */}
                    <div
                      style={{
                        background: '#eff6ff',
                        border: '1px solid #bfdbfe',
                        borderRadius: '12px',
                        padding: '14px 18px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '12px'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div
                          style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '10px',
                            backgroundColor: '#dbeafe',
                            color: '#2563eb',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0
                          }}
                        >
                          <FiTarget size={20} />
                        </div>
                        <div>
                          <div style={{ fontWeight: 700, fontSize: '0.88rem', color: '#1e3a8a' }}>
                            {loadingSchedulePreview ? (
                              <span>Calculando relatórios correspondentes...</span>
                            ) : (
                              <span>
                                ⚡ Estimativa: <strong>{syncSchedulePreview?.matching_reports_count ?? syncSchedulePreview?.count ?? 0}</strong> relatório(s) serão atualizados por este agendamento
                              </span>
                            )}
                          </div>
                          <div style={{ fontSize: '0.74rem', color: '#3b82f6' }}>
                            {(() => {
                              const samples = syncSchedulePreview?.sample_reports || syncSchedulePreview?.sample || [];
                              const countVal = syncSchedulePreview?.matching_reports_count ?? syncSchedulePreview?.count ?? 0;
                              if (samples.length > 0) {
                                return (
                                  <span>
                                    Exemplos: {samples.slice(0, 3).map(r => r.name || `Relatório #${r.id}`).join(', ')}
                                    {countVal > 3 && ` e outros ${countVal - 3}...`}
                                  </span>
                                );
                              }
                              return <span>Com base nos critérios e filtros selecionados acima</span>;
                            })()}
                          </div>
                        </div>
                      </div>

                      <button
                        type="button"
                        onClick={() => fetchSchedulePreview({
                          classifications: syncScheduleForm.classifications,
                          subtypes: syncScheduleForm.subtypes,
                          target_types: syncScheduleForm.target_types,
                          branches: syncScheduleForm.branches,
                          period_mode: syncScheduleForm.period_mode,
                          reference_year: syncScheduleForm.reference_year,
                          reference_month: syncScheduleForm.reference_month
                        })}
                        style={{
                          background: '#ffffff',
                          border: '1px solid #bfdbfe',
                          color: '#2563eb',
                          borderRadius: '8px',
                          padding: '6px 12px',
                          fontSize: '0.75rem',
                          fontWeight: 600,
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                          flexShrink: 0
                        }}
                      >
                        <FiRefreshCw size={12} className={loadingSchedulePreview ? 'spin-ico' : ''} />
                        Atualizar Estimativa
                      </button>
                    </div>

                    {/* 6. Ativação switch */}
                    <div>
                      <label style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '0.85rem', fontWeight: 600, color: '#1e293b' }}>
                        <input
                          type="checkbox"
                          checked={syncScheduleForm.is_active}
                          onChange={(e) => setSyncScheduleForm({ ...syncScheduleForm, is_active: e.target.checked })}
                          style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                        />
                        <span>Manter esta rotina de sincronização ativa imediatamente</span>
                      </label>
                    </div>
                  </div>

                  {/* Form Actions Footer */}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      gap: '10px',
                      marginTop: '16px'
                    }}
                  >
                    <button
                      type="button"
                      className="btn-modern btn-modern-secondary"
                      onClick={() => {
                        setSyncScheduleSubTab('list');
                        setScheduleActionFeedback(null);
                      }}
                    >
                      Cancelar / Voltar
                    </button>
                    {canManage && (
                      <button
                        type="submit"
                        className="btn-modern btn-modern-primary"
                        disabled={savingSyncSchedule}
                        style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                      >
                        {savingSyncSchedule ? (
                          <FiLoader size={16} className="spin-ico" />
                        ) : (
                          <FiSave size={16} />
                        )}
                        <span>{savingSyncSchedule ? 'Salvando...' : (syncScheduleForm.id ? 'Atualizar Agendamento' : 'Salvar Agendamento')}</span>
                      </button>
                    )}
                  </div>
                </form>
              )}
            </div>

            {/* Footer Close */}
            <div
              style={{
                padding: '12px 24px',
                borderTop: '1px solid #e2e8f0',
                backgroundColor: '#ffffff',
                display: 'flex',
                justifyContent: 'flex-end',
                flexShrink: 0
              }}
            >
              <button
                type="button"
                className="btn-modern btn-modern-secondary"
                onClick={() => setShowSyncScheduleModal(false)}
                style={{ fontSize: '0.82rem', padding: '6px 16px' }}
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .spin-ico { animation: spin-ico 0.8s linear infinite; display: inline-block; }
        @keyframes spin-ico { to { transform: rotate(360deg); } }
        @keyframes modalSlideIn { from { opacity: 0; transform: translateY(-20px); } to { opacity: 1; transform: translateY(0); } }

        .sortable-header {
          cursor: pointer;
          user-select: none;
          transition: background-color 0.15s ease, color 0.15s ease;
        }
        .sortable-header:hover {
          background-color: #f1f5f9;
          color: #3b82f6;
        }
      `}</style>
    </div>
  );
}

export default Relatorios;
